export const workTags = [
    {
        id: 1,
        tagName: "MUSIC"
    },
    {
        id: 2,
        tagName: "COMMERCIAL"
    },
  ]

  export const contactData ={
      showreelLink: "https://vimeo.com/1173388074",
      numberStills: 13
  }

  export const homepageTransition = {
    'default' : {
      'duration' : 1,
      'delay' : 0
    },
    'project': {
      'duration' : 1,
      'delay': 1.5
    }
  }


  export const projData = [

  {
    title: "Iceman",
    artist: "Central Cee",
    feature: null,
    vimeo: "https://vimeo.com/1173403833",
    aspectRatio: 2/1,
    tags: [
      1
    ],
    credits: {
      director: "DON Prod",
      "Creative Directors": "Lucc & Nemz",
      producer: "Jordan Rowley",
      "Line Producer": "Bertin Avdiu",
      "Production Manager": "Klevis Krasniqi",
      "Production Assistant": "Billy Allday",
      "1st AD (Day 1)": "Ty Hack",
      "2nd AD (Day 1)": "Jess",
      "1st AD (Day 2)": "Chris Malin",
      "2nd AD (Day 2)": "Sam Fullerton",
      dop: "Pieter Mattheus Snyman",
      Steadicam: "Justin Theodore",
      "1st AC": "Shane De Almeida",
      "2nd AC": "Thomas Reid",
      "Camera Trainee": "Zoe Montini",
      gaffer: "James Duffy",
      Electricians: "Tom Williams, Yeh Htoo Love, David Moga",
      Drone: "Drone Capone",
      "FPV Drone": "Louis Houiller",
      "Art Director": "Alysha Dayne Patel",
      Stylist: "Nayaab Tania",
      "Production Runner": "Emillio Stewart",
      Makeup: "Niki Henry",
      Barber: "Junior Kuteyi",
      Medic: "Declan Harris",
      Catering: "Grace & Skye",
      "Casting Director": "Lily Lepage",
      edit: "DON Prod",
      grade: "Avery Niles",
      "Title animation": "Stivthakid",
      "VFX Supervisor": "Mario Stabile",
      socials: "DON Socials"
    },
    meta: {
      date: "February 2026",
      runTime: [
        3,
        6
      ],
      location: "London",
      coords: [
        "51.6966° N",
        "0.1759° W"
      ]
    },
    description: "peaky blinders",
    keywords: [
      "music video",
      "iceman",
      "central cee",
      "countryside",
      "movie",
      "peaky blinders"
    ],
    content: {
      rollingTitle: [
        "My bro said he wanna get paid, okay, let's see what's possible",
        "Popped a pill and I feel alright, I believe I can fly, I feel unstoppable"
      ],
      splitQuote: [
        "Born to be rich",
        "but I came from rags"
      ],
      minorQuote: [
        "money",
        "is more important"
      ],
      lastQuote: [
        "Serious hate for",
        "them boys"
      ],
      heroQuote: [
        "Should I lie 'cause the truth does hurt?",
        "- Cee -"
      ]
    },
    thumbnails: {
      placeholder: "../media/main/ICEMAN/thumbnails/placeholder.webp",
      mobile: "../media/main/ICEMAN/thumbnails/mobile.webp",
      laptop: "../media/main/ICEMAN/thumbnails/tablet.webp",
      desktop: "../media/main/ICEMAN/thumbnails/desktop.webp"
    },
    gifStyling: {
      backgroundImage: "../media/main/ICEMAN/trim.mp4",
      mobileVideo: "../media/main/ICEMAN/trim_mobile.mp4"
    },
    stills: [
      {
        backgroundImage: "../media/main/ICEMAN/mobile/ICEMAN_0.webp",
        placeholder: "../media/main/ICEMAN/placeholder/ICEMAN_0.webp"
      },
      {
        backgroundImage: "../media/main/ICEMAN/mobile/ICEMAN_1.webp",
        placeholder: "../media/main/ICEMAN/placeholder/ICEMAN_1.webp"
      },
      {
        backgroundImage: "../media/main/ICEMAN/mobile/ICEMAN_2.webp",
        placeholder: "../media/main/ICEMAN/placeholder/ICEMAN_2.webp"
      },
      {
        backgroundImage: "../media/main/ICEMAN/mobile/ICEMAN_3.webp",
        placeholder: "../media/main/ICEMAN/placeholder/ICEMAN_3.webp"
      },
      {
        backgroundImage: "../media/main/ICEMAN/mobile/ICEMAN_4.webp",
        placeholder: "../media/main/ICEMAN/placeholder/ICEMAN_4.webp"
      },
      {
        backgroundImage: "../media/main/ICEMAN/mobile/ICEMAN_5.webp",
        placeholder: "../media/main/ICEMAN/placeholder/ICEMAN_5.webp"
      },
      {
        backgroundImage: "../media/main/ICEMAN/mobile/ICEMAN_6.webp",
        placeholder: "../media/main/ICEMAN/placeholder/ICEMAN_6.webp"
      },
      {
        backgroundImage: "../media/main/ICEMAN/mobile/ICEMAN_7.webp",
        placeholder: "../media/main/ICEMAN/placeholder/ICEMAN_7.webp"
      },
      {
        backgroundImage: "../media/main/ICEMAN/mobile/ICEMAN_8.webp",
        placeholder: "../media/main/ICEMAN/placeholder/ICEMAN_8.webp"
      },
      {
        backgroundImage: "../media/main/ICEMAN/mobile/ICEMAN_9.webp",
        placeholder: "../media/main/ICEMAN/placeholder/ICEMAN_9.webp"
      },
      {
        backgroundImage: "../media/main/ICEMAN/mobile/ICEMAN_10.webp",
        placeholder: "../media/main/ICEMAN/placeholder/ICEMAN_10.webp"
      }
    ]
  },
  {
    title: "Villains",
    artist: "Trapstar",
    feature: null,
    vimeo: "https://vimeo.com/1173401987",
    aspectRatio: 4/5,
    tags: [
      2
    ],
    credits: {
      director: "DON Prod",
      producer: "Adam Watts",
      "Production Manager": "Haley Bishop",
      "Production Assistant": "Laurent Durham",
      "Production Runner": "Aimee Robinson",
      "1st AD": "Jahn Ramis",
      "2nd AD": "Luke Williams",
      dop: "Michael Johnson",
      "1st AC": "Harry Coleman",
      "2nd AC": "Flynn Dennison",
      "Camera Trainee": "Antoine Law",
      FPV: "Cine Labs",
      Drone: "Drone CApone",
      gaffer: "London Lighting",
      Grip: "Brett Lamerton",
      Sound: "Calum Sample",
      "Stunt Co-Ordinator": "Nrinder Dhudwar",
      "Aerial Co-Ordinators": "Aviation",
      "H&S Advisor": "Tim Deegan",
      "Helicopter Pilot": "Ed Hardcastle",
      "Art Director": "Joe Munro",
      "Art Assistant": "Cali",
      "Location Support": "UK Film Locations",
      "Ribs and Nautical Filming": "Commercial Rib Charter",
      "Lorry Liason": "Cristopher Shiloh",
      SPACTS: "Take3",
      edit: "DON Prod",
      Colourist: "Yunus Katas",
      SFX: "Douson",
      Score: "Michael Cryne",
      Writer: "Mike Glover"
    },
    meta: {
      date: "September 2023",
      runTime: [
        1,
        27
      ],
      location: "Cranleigh",
      coords: [
        "51.14209 - 0.48374"
      ]
    },
    description: "military escort for precious trapstar cargo",
    keywords: [
      "commercial",
      "helicopters",
      "speed boats",
      "lorries and mandem"
    ],
    content: {
      rollingTitle: [
        "In life the only thing truly unique to you is your story",
        "you know who the fuck we are"
      ],
      splitQuote: [
        "We're not them",
        "we can't be"
      ],
      minorQuote: [
        "Predators dont",
        "befriend prey"
      ],
      lastQuote: [
        "Screw",
        "Them"
      ],
      heroQuote: [
        "We've been taught to follow rules all our life",
        "- Villain -"
      ]
    },
    thumbnails: {
      placeholder: "../media/main/VILLAINS/thumbnails/placeholder.webp",
      mobile: "../media/main/VILLAINS/thumbnails/mobile.webp",
      laptop: "../media/main/VILLAINS/thumbnails/tablet.webp",
      desktop: "../media/main/VILLAINS/thumbnails/desktop.webp"
    },
    gifStyling: {
      backgroundImage: "../media/main/VILLAINS/trim.mp4",
      mobileVideo: "../media/main/VILLAINS/trim_mobile.mp4"
    },
    stills: [
      {
        backgroundImage: "../media/main/VILLAINS/mobile/VILLAINS_0.webp",
        placeholder: "../media/main/VILLAINS/placeholder/VILLAINS_0.webp"
      },
      {
        backgroundImage: "../media/main/VILLAINS/mobile/VILLAINS_1.webp",
        placeholder: "../media/main/VILLAINS/placeholder/VILLAINS_1.webp"
      },
      {
        backgroundImage: "../media/main/VILLAINS/mobile/VILLAINS_2.webp",
        placeholder: "../media/main/VILLAINS/placeholder/VILLAINS_2.webp"
      },
      {
        backgroundImage: "../media/main/VILLAINS/mobile/VILLAINS_3.webp",
        placeholder: "../media/main/VILLAINS/placeholder/VILLAINS_3.webp"
      },
      {
        backgroundImage: "../media/main/VILLAINS/mobile/VILLAINS_4.webp",
        placeholder: "../media/main/VILLAINS/placeholder/VILLAINS_4.webp"
      },
      {
        backgroundImage: "../media/main/VILLAINS/mobile/VILLAINS_5.webp",
        placeholder: "../media/main/VILLAINS/placeholder/VILLAINS_5.webp"
      },
      {
        backgroundImage: "../media/main/VILLAINS/mobile/VILLAINS_6.webp",
        placeholder: "../media/main/VILLAINS/placeholder/VILLAINS_6.webp"
      }
    ]
  },
    {
    title: "AURA FOR AURA",
    artist: "Blaqbonez",
    feature: ["Pa Salieu"],
    vimeo: "https://vimeo.com/1173413340",
    aspectRatio: 3/2,
    tags: [
      1
    ],
    credits: {
      director: "DON Prod",
      dop: "Michael Johnson",
      "1st AC": "Flynn Dennison",
      "2nd AC": "Yung Antz",
      gaffer: "London Lighting",
      "1st AD": "Samuel Fullerton",
      runner: "Max Roe",
      photographer: "Ollie Buckle",
      edit: "DON Prod",
      colour: "Black Kite Studios",
      vfx: "Fede",
      "3d": "Mario Stabille",
      multimedia: "4rustle",
      titles: "Sam Bellenger"
    },
    meta: {
      date: "November 2025",
      runTime: [
        2,
        6
      ],
      location: "London",
      coords: [
        "51.5834°N",
        "0.0728°W"
      ]
    },
    description: "Warehouse business",
    keywords: [
      "music video",
      "nigeria",
      "edgy",
      "kinect",
      "film"
    ],
    content: {
      rollingTitle: [
        "I might really fall in love with a stripper",
        "Look at her back, and it's aura for aura"
      ],
      splitQuote: [
        "I love the hood",
        "I hate the hood"
      ],
      minorQuote: [
        "A match ",
        "for me?"
      ],
      lastQuote: [
        "Aura for",
        "aura"
      ],
      heroQuote: [
        "I got no filter, I'm raw",
        "- Blaqbonez -"
      ]
    },
    thumbnails: {
      placeholder: "../media/main/AURA4AURA/thumbnails/placeholder.webp",
      mobile: "../media/main/AURA4AURA/thumbnails/mobile.webp",
      laptop: "../media/main/AURA4AURA/thumbnails/tablet.webp",
      desktop: "../media/main/AURA4AURA/thumbnails/desktop.webp"
    },
    gifStyling: {
      backgroundImage: "../media/main/AURA4AURA/trim.mp4",
      mobileVideo: "../media/main/AURA4AURA/trim_mobile.mp4"
    },
    stills: [
      {
        backgroundImage: "../media/main/AURA4AURA/mobile/AURA4AURA_0.webp",
        placeholder: "../media/main/AURA4AURA/placeholder/AURA4AURA_0.webp"
      },
      {
        backgroundImage: "../media/main/AURA4AURA/mobile/AURA4AURA_1.webp",
        placeholder: "../media/main/AURA4AURA/placeholder/AURA4AURA_1.webp"
      },
      {
        backgroundImage: "../media/main/AURA4AURA/mobile/AURA4AURA_2.webp",
        placeholder: "../media/main/AURA4AURA/placeholder/AURA4AURA_2.webp"
      },
      {
        backgroundImage: "../media/main/AURA4AURA/mobile/AURA4AURA_3.webp",
        placeholder: "../media/main/AURA4AURA/placeholder/AURA4AURA_3.webp"
      },
      {
        backgroundImage: "../media/main/AURA4AURA/mobile/AURA4AURA_4.webp",
        placeholder: "../media/main/AURA4AURA/placeholder/AURA4AURA_4.webp"
      },
      {
        backgroundImage: "../media/main/AURA4AURA/mobile/AURA4AURA_5.webp",
        placeholder: "../media/main/AURA4AURA/placeholder/AURA4AURA_5.webp"
      },
      {
        backgroundImage: "../media/main/AURA4AURA/mobile/AURA4AURA_6.webp",
        placeholder: "../media/main/AURA4AURA/placeholder/AURA4AURA_6.webp"
      },
      {
        backgroundImage: "../media/main/AURA4AURA/mobile/AURA4AURA_7.webp",
        placeholder: "../media/main/AURA4AURA/placeholder/AURA4AURA_7.webp"
      }
    ]
  },
  {
    title: "No Comment",
    artist: "Fredo",
    feature: null,
    vimeo: "https://vimeo.com/1173718887",
    aspectRatio: 3/2,
    tags: [
      1
    ],
    credits: {
      director: "DON Prod",
      dop: "DON Prod",
      photographer: "Ramsey Ramone",
      edit: "DON Prod",
      colour: "DON Prod",
      titles: "Sam Bellenger",
      Sound: "Kai Goodrem"
    },
    meta: {
      date: "August 2025",
      runTime: [
        3,
        1
      ],
      location: "Thailand",
      coords: [
        "7.8804° N",
        "98.3923° E"
      ]
    },
    description: "Jungle stepping",
    keywords: [
      "music video",
      "thailand",
      "blackmagic",
      "jungle",
      "airport",
      "7/11"
    ],
    content: {
      rollingTitle: [
        "The truth hurts when you boys are homeless",
        "They wanna know what's goin' on, we'll see"
      ],
      splitQuote: [
        "run a couple M's",
        "robberies the same"
      ],
      minorQuote: [
        "Pussies goin' hard",
        "for attention"
      ],
      lastQuote: [
        "I'm a bit ",
        "rare"
      ],
      heroQuote: [
        "In this game full of lies, I'm the one who does the facts",
        "- Fredo -"
      ]
    },
    thumbnails: {
      placeholder: "../media/main/NOCOMMENT/thumbnails/placeholder.webp",
      mobile: "../media/main/NOCOMMENT/thumbnails/mobile.webp",
      laptop: "../media/main/NOCOMMENT/thumbnails/tablet.webp",
      desktop: "../media/main/NOCOMMENT/thumbnails/desktop.webp"
    },
    gifStyling: {
      backgroundImage: "../media/main/NOCOMMENT/trim.mp4",
      mobileVideo: "../media/main/NOCOMMENT/trim_mobile.mp4"
    },
    stills: [
      {
        backgroundImage: "../media/main/NOCOMMENT/mobile/NOCOMMENT_0.webp",
        placeholder: "../media/main/NOCOMMENT/placeholder/NOCOMMENT_0.webp"
      },
      {
        backgroundImage: "../media/main/NOCOMMENT/mobile/NOCOMMENT_1.webp",
        placeholder: "../media/main/NOCOMMENT/placeholder/NOCOMMENT_1.webp"
      },
      {
        backgroundImage: "../media/main/NOCOMMENT/mobile/NOCOMMENT_2.webp",
        placeholder: "../media/main/NOCOMMENT/placeholder/NOCOMMENT_2.webp"
      },
      {
        backgroundImage: "../media/main/NOCOMMENT/mobile/NOCOMMENT_3.webp",
        placeholder: "../media/main/NOCOMMENT/placeholder/NOCOMMENT_3.webp"
      },
      {
        backgroundImage: "../media/main/NOCOMMENT/mobile/NOCOMMENT_4.webp",
        placeholder: "../media/main/NOCOMMENT/placeholder/NOCOMMENT_4.webp"
      },
      {
        backgroundImage: "../media/main/NOCOMMENT/mobile/NOCOMMENT_5.webp",
        placeholder: "../media/main/NOCOMMENT/placeholder/NOCOMMENT_5.webp"
      },
      {
        backgroundImage: "../media/main/NOCOMMENT/mobile/NOCOMMENT_6.webp",
        placeholder: "../media/main/NOCOMMENT/placeholder/NOCOMMENT_6.webp"
      },
      {
        backgroundImage: "../media/main/NOCOMMENT/mobile/NOCOMMENT_7.webp",
        placeholder: "../media/main/NOCOMMENT/placeholder/NOCOMMENT_7.webp"
      },
      {
        backgroundImage: "../media/main/NOCOMMENT/mobile/NOCOMMENT_8.webp",
        placeholder: "../media/main/NOCOMMENT/placeholder/NOCOMMENT_8.webp"
      },
      {
        backgroundImage: "../media/main/NOCOMMENT/mobile/NOCOMMENT_9.webp",
        placeholder: "../media/main/NOCOMMENT/placeholder/NOCOMMENT_9.webp"
      }
    ]
  },
  {
    title: "Trilogy",
    artist: "Kidwild",
    feature: null,
    vimeo: "https://vimeo.com/1173400462",
    aspectRatio: 16/9,
    tags: [
      1
    ],
    credits: {
      director: "DON Prod",
      producer: "DON Prod",
      "Production Manager": "Campbell Anderson",
      dop: "Marti Guiver",
      AD: "Ben Gomme",
      "1st AC": "Flynn Dennison",
      "2nd AC": "Riccardo Angei",
      gaffer: "London Lighting, Ken Liew",
      Drone: "Drone Capone",
      Editor: "DON Prod",
      "Colour House": "Black Kite",
      Colourist: "Simone Chiavini"
    },
    meta: {
      date: "March 2026",
      runTime: [
        6,
        49
      ],
      location: "London",
      coords: [
        "51.53845° N",
        "-0.08286° W"
      ]
    },
    description: "Kidwild weathers the storm on his path to fame",
    keywords: [
      "Trilogy",
      "Struggle",
      "Turbulance",
      "Storm",
      "Lightning",
      "Hustle"
    ],
    content: {
      rollingTitle: [
        "They just showed me why i can't get close or trust",
        "Inside my head I'm torn, love or lust"
      ],
      splitQuote: [
        "let me do",
        "what I do best"
      ],
      minorQuote: [
        "I dont forgive",
        "and forget"
      ],
      lastQuote: [
        "Pain don't",
        "fade"
      ],
      heroQuote: [
        "I've been places no-one goes to, only life can take you",
        "- KidWild -"
      ]
    },
    thumbnails: {
      placeholder: "../media/main/TRILOGY/thumbnails/placeholder.webp",
      mobile: "../media/main/TRILOGY/thumbnails/mobile.webp",
      laptop: "../media/main/TRILOGY/thumbnails/tablet.webp",
      desktop: "../media/main/TRILOGY/thumbnails/desktop.webp"
    },
    gifStyling: {
      backgroundImage: "../media/main/TRILOGY/trim.mp4",
      mobileVideo: "../media/main/TRILOGY/trim_mobile.mp4"
    },
    stills: [
      {
        backgroundImage: "../media/main/TRILOGY/mobile/TRILOGY_0.webp",
        placeholder: "../media/main/TRILOGY/placeholder/TRILOGY_0.webp"
      },
      {
        backgroundImage: "../media/main/TRILOGY/mobile/TRILOGY_1.webp",
        placeholder: "../media/main/TRILOGY/placeholder/TRILOGY_1.webp"
      },
      {
        backgroundImage: "../media/main/TRILOGY/mobile/TRILOGY_2.webp",
        placeholder: "../media/main/TRILOGY/placeholder/TRILOGY_2.webp"
      },
      {
        backgroundImage: "../media/main/TRILOGY/mobile/TRILOGY_3.webp",
        placeholder: "../media/main/TRILOGY/placeholder/TRILOGY_3.webp"
      },
      {
        backgroundImage: "../media/main/TRILOGY/mobile/TRILOGY_4.webp",
        placeholder: "../media/main/TRILOGY/placeholder/TRILOGY_4.webp"
      },
      {
        backgroundImage: "../media/main/TRILOGY/mobile/TRILOGY_5.webp",
        placeholder: "../media/main/TRILOGY/placeholder/TRILOGY_5.webp"
      },
      {
        backgroundImage: "../media/main/TRILOGY/mobile/TRILOGY_6.webp",
        placeholder: "../media/main/TRILOGY/placeholder/TRILOGY_6.webp"
      },
      {
        backgroundImage: "../media/main/TRILOGY/mobile/TRILOGY_7.webp",
        placeholder: "../media/main/TRILOGY/placeholder/TRILOGY_7.webp"
      },
      {
        backgroundImage: "../media/main/TRILOGY/mobile/TRILOGY_8.webp",
        placeholder: "../media/main/TRILOGY/placeholder/TRILOGY_8.webp"
      }
    ]
  },
  {
    title: "Pilates",
    artist: "Kairo Keyz",
    feature: null,
    vimeo: "https://vimeo.com/1173398865",
    aspectRatio: 3/2,
    tags: [
      1
    ],
    credits: {
      director: "DON Prod",
      producer: "DON Prod",
      dop: "Michael Richard Johnson",
      "1st AC": "Jamie Oliver",
      Steadicam: "Jak Waughman",
      "B Cam": "Lifeofteej",
      edit: "DON Prod",
      vfx: "Mario Stabile",
      Colourist: "Jared Rosenthal",
      "Sound Design": "Kai Goodrem"
    },
    meta: {
      date: "August 2025",
      runTime: [
        3,
        23
      ],
      location: "London",
      coords: [
        "51.494667° N",
        "-0.051880° W"
      ]
    },
    description: "F*** subtitles",
    keywords: [
      "London",
      "Billboards",
      "Outside",
      "Takeover"
    ],
    content: {
      rollingTitle: [
        "I get hate and love in abundance, i still went up and got rich ",
        "Bad hair, bad face, saying theyre real theyre probably fake "
      ],
      splitQuote: [
        "Got enough cash",
        "like im in the trap"
      ],
      minorQuote: [
        "Turn an L",
        "into a w"
      ],
      lastQuote: [
        "good girls",
        "ain't no fun"
      ],
      heroQuote: [
        "Man know bout money, nigga thats one thing",
        "- Kairo Keyz -"
      ]
    },
    thumbnails: {
      placeholder: "../media/main/PILATES/thumbnails/placeholder.webp",
      mobile: "../media/main/PILATES/thumbnails/mobile.webp",
      laptop: "../media/main/PILATES/thumbnails/tablet.webp",
      desktop: "../media/main/PILATES/thumbnails/desktop.webp"
    },
    gifStyling: {
      backgroundImage: "../media/main/PILATES/trim.mp4",
      mobileVideo: "../media/main/PILATES/trim_mobile.mp4"
    },
    stills: [
      {
        backgroundImage: "../media/main/PILATES/mobile/PILATES_0.webp",
        placeholder: "../media/main/PILATES/placeholder/PILATES_0.webp"
      },
      {
        backgroundImage: "../media/main/PILATES/mobile/PILATES_1.webp",
        placeholder: "../media/main/PILATES/placeholder/PILATES_1.webp"
      },
      {
        backgroundImage: "../media/main/PILATES/mobile/PILATES_2.webp",
        placeholder: "../media/main/PILATES/placeholder/PILATES_2.webp"
      },
      {
        backgroundImage: "../media/main/PILATES/mobile/PILATES_3.webp",
        placeholder: "../media/main/PILATES/placeholder/PILATES_3.webp"
      },
      {
        backgroundImage: "../media/main/PILATES/mobile/PILATES_4.webp",
        placeholder: "../media/main/PILATES/placeholder/PILATES_4.webp"
      },
      {
        backgroundImage: "../media/main/PILATES/mobile/PILATES_5.webp",
        placeholder: "../media/main/PILATES/placeholder/PILATES_5.webp"
      },
      {
        backgroundImage: "../media/main/PILATES/mobile/PILATES_6.webp",
        placeholder: "../media/main/PILATES/placeholder/PILATES_6.webp"
      },
      {
        backgroundImage: "../media/main/PILATES/mobile/PILATES_7.webp",
        placeholder: "../media/main/PILATES/placeholder/PILATES_7.webp"
      },
      {
        backgroundImage: "../media/main/PILATES/mobile/PILATES_8.webp",
        placeholder: "../media/main/PILATES/placeholder/PILATES_8.webp"
      }
    ]
  },
  {
    title: "Century",
    artist: "EsDeeKid",
    feature: null,
    vimeo: "https://vimeo.com/1158109771/f1b6b8796f",
    aspectRatio: 3/2,
    tags: [
      1
    ],
    credits: {
      director: "DON Prod X Archie Erskine",
      dop: "Michael Johnson",
      edit: "DON Prod X Archie Erskine",
      colour: "Avery Niles",
      Photos: "Ramsey Ramone",
      vfx: "Noahsocold"
    },
    meta: {
      date: "January 2026",
      runTime: [
        1,
        50
      ],
      location: "Liverpool",
      coords: [
        "53°26′20″N 2°57′59″W"
      ]
    },
    description: "Scouse batman on vertical anamorphics",
    keywords: [
      "Liverpool",
      "dark",
      "mizzy night",
      "bold and eager"
    ],
    content: {
      rollingTitle: [
        "I'm the same kid with the same friends ",
        "Posted up in the same ends "
      ],
      splitQuote: [
        "I'm the boy",
        "I'm the boss"
      ],
      minorQuote: [
        "I'm bold",
        "I'm eager"
      ],
      lastQuote: [
        "they can't",
        "step to me"
      ],
      heroQuote: [
        "I'm the hardest out of the century",
        "- Esdeekid -"
      ]
    },
    thumbnails: {
      placeholder: "../media/main/CENTURY/thumbnails/placeholder.webp",
      mobile: "../media/main/CENTURY/thumbnails/mobile.webp",
      laptop: "../media/main/CENTURY/thumbnails/tablet.webp",
      desktop: "../media/main/CENTURY/thumbnails/desktop.webp"
    },
    gifStyling: {
      backgroundImage: "../media/main/CENTURY/trim.mp4",
      mobileVideo: "../media/main/CENTURY/trim_mobile.mp4"
    },
    stills: [
      {
        backgroundImage: "../media/main/CENTURY/mobile/CENTURY_0.webp",
        placeholder: "../media/main/CENTURY/placeholder/CENTURY_0.webp"
      },
      {
        backgroundImage: "../media/main/CENTURY/mobile/CENTURY_1.webp",
        placeholder: "../media/main/CENTURY/placeholder/CENTURY_1.webp"
      },
      {
        backgroundImage: "../media/main/CENTURY/mobile/CENTURY_2.webp",
        placeholder: "../media/main/CENTURY/placeholder/CENTURY_2.webp"
      },
      {
        backgroundImage: "../media/main/CENTURY/mobile/CENTURY_3.webp",
        placeholder: "../media/main/CENTURY/placeholder/CENTURY_3.webp"
      },
      {
        backgroundImage: "../media/main/CENTURY/mobile/CENTURY_4.webp",
        placeholder: "../media/main/CENTURY/placeholder/CENTURY_4.webp"
      },
      {
        backgroundImage: "../media/main/CENTURY/mobile/CENTURY_5.webp",
        placeholder: "../media/main/CENTURY/placeholder/CENTURY_5.webp"
      },
      {
        backgroundImage: "../media/main/CENTURY/mobile/CENTURY_6.webp",
        placeholder: "../media/main/CENTURY/placeholder/CENTURY_6.webp"
      },
      {
        backgroundImage: "../media/main/CENTURY/mobile/CENTURY_7.webp",
        placeholder: "../media/main/CENTURY/placeholder/CENTURY_7.webp"
      }
    ]
  },
  {
    title: "Birthday",
    artist: "Fredo",
    feature: ["Burna Boy", "Steel Bangelz"],
    vimeo: "https://vimeo.com/1173396942",
    aspectRatio: 3/2,
    tags: [
      1
    ],
    credits: {
      director: "DON Prod",
      producer: "DON Prod",
      dop: "Michael Richard Johnson",
      gaffer: "London Lighting",
      grade: "Avery Niles",
      titles: "Sam Bellenger"
    },
    meta: {
      date: "October 2025",
      runTime: [
        2,
        46
      ],
      location: "Lagos, Nigeria",
      coords: [
        "6.6137° N",
        "3.3553° E"
      ]
    },
    description: "Nigerian Takeover",
    keywords: [
      "Private Jetting",
      "Luxury",
      "African Giant",
      "Lagos"
    ],
    content: {
      rollingTitle: [
        "Do it, go like it's your birthday ",
        "'Cause your body is the life of the party, baby "
      ],
      splitQuote: [
        "Put it all over me",
        "Give you the whole of me"
      ],
      minorQuote: [
        "Your body",
        "been calling me"
      ],
      lastQuote: [
        "Body",
        "and soul"
      ],
      heroQuote: [
        "I know you feel it 'cause it's written all over your face",
        "- Burna Boy -"
      ]
    },
    thumbnails: {
      placeholder: "../media/main/BIRTHDAY/thumbnails/placeholder.webp",
      mobile: "../media/main/BIRTHDAY/thumbnails/mobile.webp",
      laptop: "../media/main/BIRTHDAY/thumbnails/tablet.webp",
      desktop: "../media/main/BIRTHDAY/thumbnails/desktop.webp"
    },
    gifStyling: {
      backgroundImage: "../media/main/BIRTHDAY/trim.mp4",
      mobileVideo: "../media/main/BIRTHDAY/trim_mobile.mp4"
    },
    stills: [
      {
        backgroundImage: "../media/main/BIRTHDAY/mobile/BIRTHDAY_0.webp",
        placeholder: "../media/main/BIRTHDAY/placeholder/BIRTHDAY_0.webp"
      },
      {
        backgroundImage: "../media/main/BIRTHDAY/mobile/BIRTHDAY_1.webp",
        placeholder: "../media/main/BIRTHDAY/placeholder/BIRTHDAY_1.webp"
      },
      {
        backgroundImage: "../media/main/BIRTHDAY/mobile/BIRTHDAY_2.webp",
        placeholder: "../media/main/BIRTHDAY/placeholder/BIRTHDAY_2.webp"
      },
      {
        backgroundImage: "../media/main/BIRTHDAY/mobile/BIRTHDAY_3.webp",
        placeholder: "../media/main/BIRTHDAY/placeholder/BIRTHDAY_3.webp"
      },
      {
        backgroundImage: "../media/main/BIRTHDAY/mobile/BIRTHDAY_4.webp",
        placeholder: "../media/main/BIRTHDAY/placeholder/BIRTHDAY_4.webp"
      },
      {
        backgroundImage: "../media/main/BIRTHDAY/mobile/BIRTHDAY_5.webp",
        placeholder: "../media/main/BIRTHDAY/placeholder/BIRTHDAY_5.webp"
      },
      {
        backgroundImage: "../media/main/BIRTHDAY/mobile/BIRTHDAY_6.webp",
        placeholder: "../media/main/BIRTHDAY/placeholder/BIRTHDAY_6.webp"
      }
    ]
  },
  {
    title: "Son",
    artist: "",
    feature: null,
    vimeo: "https://vimeo.com/1158110277/d19f7701e1",
    aspectRatio: 4/3,
    tags: [
      2
    ],
    credits: {
      director: "DON Prod",
      producer: "Aleksandra Zalesinka",
      dop: "DON Prod",
      "Gaffer (Lisbon)": "Rodrigo Godinho",
      "Photographer (Lisbon)": "Alisson Gabriel",
      "Gaffer (Milan)": "Matteo Corti",
      "Photographer (Milan)": "Stovha",
      "Sound Op (Milan)": "Marcello La Fortezza",
      vfx: "Mario Stabile",
      multimedia: "4rustle",
      "Sound Design": "Elliot Tay",
      edit: "DON Prod",
      grade: "Mattia Saggiomo"
    },
    meta: {
      date: "October 2025",
      runTime: [
        0,
        57
      ],
      location: "Milan, Lisbon",
      coords: [
        "38.768423",
        "-9.092499"
      ]
    },
    description: "No cap",
    keywords: [
      "Headliner",
      "Multimedia",
      "3D",
      "Superstars"
    ],
    content: {
      rollingTitle: [
        "",
        ""
      ],
      splitQuote: [
        "",
        ""
      ],
      minorQuote: [
        "",
        ""
      ],
      lastQuote: [
        "",
        ""
      ],
      heroQuote: [
        "",
        ""
      ]
    },
    thumbnails: {
      placeholder: "../media/main/SON/thumbnails/placeholder.webp",
      mobile: "../media/main/SON/thumbnails/mobile.webp",
      laptop: "../media/main/SON/thumbnails/tablet.webp",
      desktop: "../media/main/SON/thumbnails/desktop.webp"
    },
    gifStyling: {
      backgroundImage: "../media/main/SON/trim.mp4",
      mobileVideo: "../media/main/SON/trim_mobile.mp4"
    },
    stills: [
      {
        backgroundImage: "../media/main/SON/mobile/SON_0.webp",
        placeholder: "../media/main/SON/placeholder/SON_0.webp"
      },
      {
        backgroundImage: "../media/main/SON/mobile/SON_1.webp",
        placeholder: "../media/main/SON/placeholder/SON_1.webp"
      },
      {
        backgroundImage: "../media/main/SON/mobile/SON_2.webp",
        placeholder: "../media/main/SON/placeholder/SON_2.webp"
      },
      {
        backgroundImage: "../media/main/SON/mobile/SON_3.webp",
        placeholder: "../media/main/SON/placeholder/SON_3.webp"
      },
      {
        backgroundImage: "../media/main/SON/mobile/SON_4.webp",
        placeholder: "../media/main/SON/placeholder/SON_4.webp"
      }
    ]
  },
  {
    title: "Bellingham",
    artist: "Headie One",
    feature: null,
    vimeo: "https://vimeo.com/1158110026/404ad55952",
    aspectRatio: 3/2,
    tags: [
      1
    ],
    credits: {
      director: "DON Prod",
      dop: "DON Prod",
      edit: "DON Prod",
      colour: "Avery Niles",
      vfx: "Fede"
    },
    meta: {
      date: "December 2025",
      runTime: [
        2,
        41
      ],
      location: "Madrid",
      coords: [
        "40.4530° N",
        "3.6884° W"
      ]
    },
    description: "A desert in spain?",
    keywords: [
      "Bellingham",
      "Headie",
      "Desert",
      "Penthouse",
      "Luxury Vibes"
    ],
    content: {
      rollingTitle: [
        "My man said he got hammers for sale again ",
        "I ain't Jude, but I bet you I'm bellin' him "
      ],
      splitQuote: [
        "Me and her eat",
        "it's Michelin"
      ],
      minorQuote: [
        "I look good",
        "in everything"
      ],
      lastQuote: [
        "Talkin'",
        "my shit"
      ],
      heroQuote: [
        "They want me back on the trench again, I don't know who's genuine",
        " - Headie One -"
      ]
    },
    thumbnails: {
      placeholder: "../media/main/BELLINGHAM/thumbnails/placeholder.webp",
      mobile: "../media/main/BELLINGHAM/thumbnails/mobile.webp",
      laptop: "../media/main/BELLINGHAM/thumbnails/tablet.webp",
      desktop: "../media/main/BELLINGHAM/thumbnails/desktop.webp"
    },
    gifStyling: {
      backgroundImage: "../media/main/BELLINGHAM/trim.mp4",
      mobileVideo: "../media/main/BELLINGHAM/trim_mobile.mp4"
    },
    stills: [
      {
        backgroundImage: "../media/main/BELLINGHAM/mobile/BELLINGHAM_0.webp",
        placeholder: "../media/main/BELLINGHAM/placeholder/BELLINGHAM_0.webp"
      },
      {
        backgroundImage: "../media/main/BELLINGHAM/mobile/BELLINGHAM_1.webp",
        placeholder: "../media/main/BELLINGHAM/placeholder/BELLINGHAM_1.webp"
      },
      {
        backgroundImage: "../media/main/BELLINGHAM/mobile/BELLINGHAM_2.webp",
        placeholder: "../media/main/BELLINGHAM/placeholder/BELLINGHAM_2.webp"
      },
      {
        backgroundImage: "../media/main/BELLINGHAM/mobile/BELLINGHAM_3.webp",
        placeholder: "../media/main/BELLINGHAM/placeholder/BELLINGHAM_3.webp"
      },
      {
        backgroundImage: "../media/main/BELLINGHAM/mobile/BELLINGHAM_4.webp",
        placeholder: "../media/main/BELLINGHAM/placeholder/BELLINGHAM_4.webp"
      },
      {
        backgroundImage: "../media/main/BELLINGHAM/mobile/BELLINGHAM_5.webp",
        placeholder: "../media/main/BELLINGHAM/placeholder/BELLINGHAM_5.webp"
      },
      {
        backgroundImage: "../media/main/BELLINGHAM/mobile/BELLINGHAM_6.webp",
        placeholder: "../media/main/BELLINGHAM/placeholder/BELLINGHAM_6.webp"
      },
      {
        backgroundImage: "../media/main/BELLINGHAM/mobile/BELLINGHAM_7.webp",
        placeholder: "../media/main/BELLINGHAM/placeholder/BELLINGHAM_7.webp"
      }
    ]
  },
  {
    title: "Eight PM",
    artist: "Nemzzz",
    feature: null,
    vimeo: "https://vimeo.com/1158109130/0d82fdca60",
    aspectRatio: 3/2,
    tags: [
      1
    ],
    credits: {
      director: "DON Prod",
      dop: "DON Prod",
      edit: "DON Prod",
      "Prod Company": "Oraefi Lab",
      "Production Manager": "Bjatur Northfjord",
      "Production Coordinator": "Isak Ernir",
      gaffer: "Hilmar Mathiesen",
      "Drone Pilot": "Benjamin Hardman",
      colour: "Avery Niles"
    },
    meta: {
      date: "October 2025",
      runTime: [
        2,
        41
      ],
      location: "Iceland",
      coords: [
        "64.1470° N",
        "21.9408° W"
      ]
    },
    description: "66 Degrees North",
    keywords: [
      "Iceland",
      "Fisherman",
      "Volcanoes",
      "Glaciers",
      "Dark",
      "Snow",
      "Frames"
    ],
    content: {
      rollingTitle: [
        "Put your hand in the air if you ain't been broke in a minute ",
        "Now keep your hand in the air if you're tryna repent for sinnin' "
      ],
      splitQuote: [
        "from the block",
        "just like you"
      ],
      minorQuote: [
        "losin' sleep",
        "so I can keep on winning"
      ],
      lastQuote: [
        "laughed at ",
        "me back then"
      ],
      heroQuote: [
        "Still tryna ball like I'm in the Premier League, like back when I mentioned Rico",
        "- Nemzzz -"
      ]
    },
    thumbnails: {
      placeholder: "../media/main/8PM/thumbnails/placeholder.webp",
      mobile: "../media/main/8PM/thumbnails/mobile.webp",
      laptop: "../media/main/8PM/thumbnails/tablet.webp",
      desktop: "../media/main/8PM/thumbnails/desktop.webp"
    },
    gifStyling: {
      backgroundImage: "../media/main/8PM/trim.mp4",
      mobileVideo: "../media/main/8PM/trim_mobile.mp4"
    },
    stills: [
      {
        backgroundImage: "../media/main/8PM/mobile/8PM_0.webp",
        placeholder: "../media/main/8PM/placeholder/8PM_0.webp"
      },
      {
        backgroundImage: "../media/main/8PM/mobile/8PM_1.webp",
        placeholder: "../media/main/8PM/placeholder/8PM_1.webp"
      },
      {
        backgroundImage: "../media/main/8PM/mobile/8PM_2.webp",
        placeholder: "../media/main/8PM/placeholder/8PM_2.webp"
      },
      {
        backgroundImage: "../media/main/8PM/mobile/8PM_3.webp",
        placeholder: "../media/main/8PM/placeholder/8PM_3.webp"
      },
      {
        backgroundImage: "../media/main/8PM/mobile/8PM_4.webp",
        placeholder: "../media/main/8PM/placeholder/8PM_4.webp"
      },
      {
        backgroundImage: "../media/main/8PM/mobile/8PM_5.webp",
        placeholder: "../media/main/8PM/placeholder/8PM_5.webp"
      },
      {
        backgroundImage: "../media/main/8PM/mobile/8PM_6.webp",
        placeholder: "../media/main/8PM/placeholder/8PM_6.webp"
      },
      {
        backgroundImage: "../media/main/8PM/mobile/8PM_7.webp",
        placeholder: "../media/main/8PM/placeholder/8PM_7.webp"
      },
      {
        backgroundImage: "../media/main/8PM/mobile/8PM_8.webp",
        placeholder: "../media/main/8PM/placeholder/8PM_8.webp"
      },
      {
        backgroundImage: "../media/main/8PM/mobile/8PM_9.webp",
        placeholder: "../media/main/8PM/placeholder/8PM_9.webp"
      }
    ]
  },
    {
      title: "GEEKIN",
      artist: "Nafe Smallz",
      feature: ["AJ Tracey"],
      vimeo: "https://vimeo.com/1057132334/422c7b2c2b",
      aspectRatio: 4/3,
      tags : [1],
      credits: {
        director: "DON PROD",
        dop: "Michael R. Johsnon",
        first_ac: "Christian Wood",
        second_ac: "Antoine Law",
        first_ad: "Samuel Fullerton",
        second_ad: "Jodie Joy",
        lighting: "London Lighting",
        art: "Jordan Chandler",
        editor: "Samuel Maton",
        colourist: "Jared Rosenthal",
        sound_design: "Kai Goodrem",
        VFX: "Hwang Production",
        VHS: "4PM Recordings"
      },
      meta: {
        date: "February, 2024",
        runTime: [2, 49],
        location: "Greenwich, London",
        coords: ["51.5072° N", "0.1276° W"],
      },
      description: "A massive white cove, VHS, disposables camera and VFX galore.",
      keywords: ["music video", "arri alexa", "vfx", "uk rap"],
      content: {
        rollingTitle: [
          " We buy tequila in crates and tell girls bring their mates.",
          " Now they're wet 'cause I came in with Nafe."
        ],
        splitQuote: [
          'Copped a Rolls',
          'It Came with a girl'
        ],
        minorQuote: [
          "", 
          ""
        ],
        lastQuote: [
          'Lil\' bitch,',
          'you geekin\'?'
        ],
        heroQuote: [
          'Crushin\' the molly, I\'m geekin\'.',
          '- NAFE -'
        ]
      },
      thumbnails: {
        placeholder: "../media/main/GEEKIN/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/GEEKIN/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/GEEKIN/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/GEEKIN/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/GEEKIN/trim.mp4",
        mobileVideo: "../media/main/GEEKIN/trim_mobile.mp4"
      },
      tags : [1],
      stills: [
        {
          backgroundImage: "../media/main/GEEKIN/mobile/GEEKIN_0.webp",
          placeholder: "../media/main/GEEKIN/placeholder/GEEKIN_0.webp"
        },
        {
          backgroundImage: "../media/main/GEEKIN/mobile/GEEKIN_1.webp",
          placeholder: "../media/main/GEEKIN/placeholder/GEEKIN_1.webp"
        },
        {
          backgroundImage: "../media/main/GEEKIN/mobile/GEEKIN_2.webp",
          placeholder: "../media/main/GEEKIN/placeholder/GEEKIN_2.webp"
        },
        {
          backgroundImage: "../media/main/GEEKIN/mobile/GEEKIN_3.webp",
          placeholder: "../media/main/GEEKIN/placeholder/GEEKIN_3.webp"
        },
        {
          backgroundImage: "../media/main/GEEKIN/mobile/GEEKIN_4.webp",
          placeholder: "../media/main/GEEKIN/placeholder/GEEKIN_4.webp"
        },
        {
          backgroundImage: "../media/main/GEEKIN/mobile/GEEKIN_6.webp",
          placeholder: "../media/main/GEEKIN/placeholder/GEEKIN_6.webp"
        },
        {
          backgroundImage: "../media/main/GEEKIN/mobile/GEEKIN_5.webp",
          placeholder: "../media/main/GEEKIN/placeholder/GEEKIN_5.webp"
        }
        
      ]
    },
    {
      title: "COLD",
      artist: "Nemzzz",
      feature: null,
      vimeo: "https://vimeo.com/1089332391",
      aspectRatio: 4/3,
      tags : [1],
      credits: {
        director: "DONPROD",
        producer: "Lizzie Armanto",
        dop: "Michael Johnson",
        gaffer: "London Lighting",
        socials: "DON Socials",
        edit: "DONPROD",
        VFX: "Federico Bocchi",
        multimedia: "Neegz Istuoju",
        grade: "Mattia Saggiomo",
        biker: "Inner City Riderz",
        dog: "Hazel TV",
      },
      meta: {
        date: "February, 2025",
        runTime: [2, 23],
        location: "London",
        coords: ["51.5072° N", "0.1276° W"],
      },
      description: "doing it old school",
      keywords: ["music video", "arri alexa", "vfx", "uk rap"],
      content: {
        rollingTitle: ["Shit, what you sayin', though, man?","I don’t hear from you no more, bruv, you good?"],
        splitQuote: ['I\'m posted up','tryna get it'],
        minorQuote: ["", ""],
        lastQuote: ['I didn\'t,','see no one'],
        heroQuote: ['Kind of weird I miss that life, right?','- NEMZZZ -']
      },
      thumbnails: {
        placeholder: "../media/main/COLD/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/COLD/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/COLD/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/COLD/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/COLD/trim.mp4",
        mobileVideo: "../media/main/COLD/trim_mobile.mp4"
      },
      tags : [1],
      stills: [
        {
          backgroundImage: "../media/main/COLD/mobile/COLD_0.webp",
          placeholder: "../media/main/COLD/placeholder/COLD_0.webp"
        },
        {
          backgroundImage: "../media/main/COLD/mobile/COLD_1.webp",
          placeholder: "../media/main/COLD/placeholder/COLD_1.webp"
        },
        {
          backgroundImage: "../media/main/COLD/mobile/COLD_2.webp",
          placeholder: "../media/main/COLD/placeholder/COLD_2.webp"
        },
        {
          backgroundImage: "../media/main/COLD/mobile/COLD_3.webp",
          placeholder: "../media/main/COLD/placeholder/COLD_3.webp"
        },
        {
          backgroundImage: "../media/main/COLD/mobile/COLD_4.webp",
          placeholder: "../media/main/COLD/placeholder/COLD_4.webp"
        }
      ]
    },
    // {
    //   title: "Taste",
    //   artist: "Nemzzz",
    //   feature: ["D-Block Europe"],
    //   vimeo: "https://vimeo.com/1089337385",
    //   aspectRatio: 16/9,
    //   tags : [1],
    //   credits: {
    //     director: "DONPROD",
    //     dop: "Michael Johnson",
    //     first_ac: "Flynn Dennison",
    //     gaffer: "London Lighting",
    //     edit: "DONPROD",
    //     grade: "Mattia Saggiomo",
    //   },
    //   meta: {
    //     date: "February, 2025",
    //     runTime: [2, 46],
    //     location: "London",
    //     coords: ["51.5072° N", "0.1276° W"],
    //   },
    //   description: "From London to LA",
    //   keywords: ["music video", "uk rap"],
    //   content: {
    //     rollingTitle: ["She look bad every day","Chains all up in her face"],
    //     splitQuote: ['She got a man',' I didn\'t hear that'],
    //     minorQuote: ["", ""],
    //     lastQuote: ['I like how','she taste'],
    //     heroQuote: ['Made her walk just so I can stare back.', '- NEMZZ -']
    //   },
    //   thumbnails: {
    //     placeholder: "../media/main/DBE/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
    //     mobile: "../media/main/DBE/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
    //     laptop: "../media/main/DBE/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
    //     desktop: "../media/main/DBE/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
    //   },
    //   gifStyling: {
    //     backgroundImage: "../media/main/DBE/trim.mp4",
    //     mobileVideo: "../media/main/DBE/trim_mobile.mp4"
    //   },
    //   tags : [1],
    //   stills: [
    //     {
    //       backgroundImage: "../media/main/DBE/mobile/DBE_0.webp",
    //       placeholder: "../media/main/DBE/placeholder/DBE_0.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/DBE/mobile/DBE_1.webp",
    //       placeholder: "../media/main/DBE/placeholder/DBE_1.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/DBE/mobile/DBE_2.webp",
    //       placeholder: "../media/main/DBE/placeholder/DBE_2.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/DBE/mobile/DBE_3.webp",
    //       placeholder: "../media/main/DBE/placeholder/DBE_3.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/DBE/mobile/DBE_4.webp",
    //       placeholder: "../media/main/DBE/placeholder/DBE_4.webp"
    //     }
    //   ]
    // },
    {
      title: "Hooligan",
      artist: "Rushy",
      feature: null,
      vimeo: "https://vimeo.com/1089337173",
      aspectRatio: 4/3,
      tags : [1],
      credits: {
        director: "DONPROD",
        dop: "Michael Johnson",
        photography: "Ramsey Ramone",
        colourist: "Mattia Saggiomo",
        sound_design: "Kai Goodrem",
        PA: "Harry Panayoutiou",
        runner: "Kai Labrooy"
      },
      meta: {
        date: "February, 2025",
        runTime: [2, 34],
        location: "London",
        coords: ["51.5072° N", "0.1276° W"],
      },
      description: "Back to the roots on the Isle of Wight",
      keywords: ["music video", "uk rap"],
      content: {
        rollingTitle: ["Fake friends tryna hold me back ","Say I changed, they don't know me like that "],
        splitQuote: ['I had to look up','I ain\'t even holy'],
        minorQuote: ["", ""],
        lastQuote: ['Miami Vice','like I\'m Tony'],
        heroQuote: ['You don\'t know me but you act like you know me.','- RUSHY -']
      },
      thumbnails: {
        placeholder: "../media/main/HOOLIGAN/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/HOOLIGAN/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/HOOLIGAN/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/HOOLIGAN/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/HOOLIGAN/trim.mp4",
        mobileVideo: "../media/main/HOOLIGAN/trim_mobile.mp4"
      },
      tags : [1],
      stills: [
        {
          backgroundImage: "../media/main/HOOLIGAN/mobile/HOOLIGAN_0.webp",
          placeholder: "../media/main/HOOLIGAN/placeholder/HOOLIGAN_0.webp"
        },
        {
          backgroundImage: "../media/main/HOOLIGAN/mobile/HOOLIGAN_1.webp",
          placeholder: "../media/main/HOOLIGAN/placeholder/HOOLIGAN_1.webp"
        },
        {
          backgroundImage: "../media/main/HOOLIGAN/mobile/HOOLIGAN_2.webp",
          placeholder: "../media/main/HOOLIGAN/placeholder/HOOLIGAN_2.webp"
        },
        {
          backgroundImage: "../media/main/HOOLIGAN/mobile/HOOLIGAN_3.webp",
          placeholder: "../media/main/HOOLIGAN/placeholder/HOOLIGAN_3.webp"
        },
        {
          backgroundImage: "../media/main/HOOLIGAN/mobile/HOOLIGAN_4.webp",
          placeholder: "../media/main/HOOLIGAN/placeholder/HOOLIGAN_4.webp"
        }
      ]
    },
    {
      title: "IIATSTU",
      artist: "Malevolence",
      feature: null,
      vimeo: "https://vimeo.com/1089337217",
      aspectRatio: 600/238,
      tags : [1],
      credits: {
        director: "DONPROD",
        dop: "Michael Johnson",
        producer: "Jamie Cox",
        pm: "Molly Carson",
        first_ad: "Samuel James Fullerton",
        pa: "Polly Coombes",
        runner: "Kai Labrooy",
        first_ac: "Christian Wood",
        second_ac: "Antoine Law",
        gaffer: "London Lighting",
        sound: "Harry Whittingham",
        art_director: "Elana Katz",
        art_assistant: "Riya Jutla"
      },
      meta: {
        date: "2025",
        runTime: [6, 19],
        location: "London",
        coords: ["51.5072° N", "0.1276° W"],
      },
      description: "a heavy metal heist ",
      keywords: ["music video", "uk rap"],
      content: {
        rollingTitle: ["Hypocritical critics, always so cynical ","Led to believe what thеy're feeling is reciprocal "],
        splitQuote: ['A friend of you','no friend of mine'],
        minorQuote: ["", ""],
        lastQuote: [' pour a glass,','raise a toast'],
        heroQuote: ['Another dickhead with a lot to say.','- MALEVOLENCE -']
      },
      thumbnails: {
        placeholder: "../media/main/MALEVIOLENCE/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/MALEVIOLENCE/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/MALEVIOLENCE/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/MALEVIOLENCE/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/MALEVIOLENCE/trim.mp4",
        mobileVideo: "../media/main/MALEVIOLENCE/trim_mobile.mp4"
      },
      tags : [1],
      stills: [
        {
          backgroundImage: "../media/main/MALEVIOLENCE/mobile/MALEVIOLENCE_0.webp",
          placeholder: "../media/main/MALEVIOLENCE/placeholder/MALEVIOLENCE_0.webp"
        },
        {
          backgroundImage: "../media/main/MALEVIOLENCE/mobile/MALEVIOLENCE_1.webp",
          placeholder: "../media/main/MALEVIOLENCE/placeholder/MALEVIOLENCE_1.webp"
        },
        {
          backgroundImage: "../media/main/MALEVIOLENCE/mobile/MALEVIOLENCE_2.webp",
          placeholder: "../media/main/MALEVIOLENCE/placeholder/MALEVIOLENCE_2.webp"
        },
        {
          backgroundImage: "../media/main/MALEVIOLENCE/mobile/MALEVIOLENCE_3.webp",
          placeholder: "../media/main/MALEVIOLENCE/placeholder/MALEVIOLENCE_3.webp"
        },
        {
          backgroundImage: "../media/main/MALEVIOLENCE/mobile/MALEVIOLENCE_4.webp",
          placeholder: "../media/main/MALEVIOLENCE/placeholder/MALEVIOLENCE_4.webp"
        }
      ]
    },
    {
      title: "No Introduction",
      artist: "Central Cee",
      feature: null,
      vimeo: "https://vimeo.com/1089336999",
      aspectRatio: 1920/1080,
      tags : [1],
      credits: {
        director: "DONPROD",
        dop: "DONPROD",
        edit: "DONPROD",
        color: "Mattia Saggiomo",
        titles: "Jost Mess"
      },
      meta: {
        date: "2025",
        runTime: [2, 54],
        location: "All over...",
        coords: ["51.5072° N", "0.1276° W"],
      },
      description: "Touring with Cench",
      keywords: ["music video", "uk rap", "tour"],
      content: {
        rollingTitle: ["Like anytime I get on the mic, it don't cover a hundred regions","Sweden, Norwegian, New Zealand, Australian, Arab, Armenian, even Asia"],
        splitQuote: ['Tryna pretend they don\'t','know who Cee is'],
        minorQuote: ["", ""],
        lastQuote: ['NO INTRODUCTION','NEEDED'],
        heroQuote: ['I\'m feelin\' pain, but I can\'t complain, my life was harder before the fame.','- Cee - ']
      },
      thumbnails: {
        placeholder: "../media/main/NOINTRO/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/NOINTRO/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/NOINTRO/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/NOINTRO/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/NOINTRO/trim.mp4",
        mobileVideo: "../media/main/NOINTRO/trim_mobile.mp4"
      },
      tags : [1],
      stills: [
        {
          backgroundImage: "../media/main/NOINTRO/mobile/NOINTRO_0.webp",
          placeholder: "../media/main/NOINTRO/placeholder/NOINTRO_0.webp"
        },
        {
          backgroundImage: "../media/main/NOINTRO/mobile/NOINTRO_1.webp",
          placeholder: "../media/main/NOINTRO/placeholder/NOINTRO_1.webp"
        },
        {
          backgroundImage: "../media/main/NOINTRO/mobile/NOINTRO_2.webp",
          placeholder: "../media/main/NOINTRO/placeholder/NOINTRO_2.webp"
        },
        {
          backgroundImage: "../media/main/NOINTRO/mobile/NOINTRO_3.webp",
          placeholder: "../media/main/NOINTRO/placeholder/NOINTRO_3.webp"
        },
        {
          backgroundImage: "../media/main/NOINTRO/mobile/NOINTRO_4.webp",
          placeholder: "../media/main/NOINTRO/placeholder/NOINTRO_4.webp"
        }
      ]
    },
    {
      title: "Digos",
      artist: "Shiva",
      feature: ['Paky'],
      vimeo: "https://vimeo.com/1089337088",
      aspectRatio: 16/9,
      tags : [1],
      credits: {
        director: "DONPROD",
        creative_director: "Ivan Obustellini",
        executive_producer: "@naderabouelella",
      },
      meta: {
        date: "December 2024",
        runTime: [2, 28],
        location: "Milan",
        coords: ["45.4685° N", "9.1824° W"],
      },
      description: "Milan madness on film",
      keywords: ["music video", "uk rap"],
      content: {
        rollingTitle: ["Questo Nokia muove palline ","Non sto giocando mica ad 8 Pool "],
        splitQuote: ['Mezzo milione','solo alla firma'],
        minorQuote: ["", ""],
        lastQuote: ['Paky e Shiva','fumiamo shisha'],
        heroQuote: ['Sporchiamo i cup con qualche linea.','- SHIVA -']
      },
      thumbnails: {
        placeholder: "../media/main/PACKYSHIVA/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/PACKYSHIVA/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/PACKYSHIVA/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/PACKYSHIVA/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/PACKYSHIVA/trim.mp4",
        mobileVideo: "../media/main/PACKYSHIVA/trim_mobile.mp4"
      },
      tags : [1],
      stills: [
        {
          backgroundImage: "../media/main/PACKYSHIVA/mobile/PACKYSHIVA_0.webp",
          placeholder: "../media/main/PACKYSHIVA/placeholder/PACKYSHIVA_0.webp"
        },
        {
          backgroundImage: "../media/main/PACKYSHIVA/mobile/PACKYSHIVA_1.webp",
          placeholder: "../media/main/PACKYSHIVA/placeholder/PACKYSHIVA_1.webp"
        },
        {
          backgroundImage: "../media/main/PACKYSHIVA/mobile/PACKYSHIVA_2.webp",
          placeholder: "../media/main/PACKYSHIVA/placeholder/PACKYSHIVA_2.webp"
        },
        {
          backgroundImage: "../media/main/PACKYSHIVA/mobile/PACKYSHIVA_3.webp",
          placeholder: "../media/main/PACKYSHIVA/placeholder/PACKYSHIVA_3.webp"
        },
        {
          backgroundImage: "../media/main/PACKYSHIVA/mobile/PACKYSHIVA_4.webp",
          placeholder: "../media/main/PACKYSHIVA/placeholder/PACKYSHIVA_4.webp"
        }
      ]
    },
    {
      title: "Sombrero",
      artist: "Blanco",
      feature: null,
      vimeo: "https://vimeo.com/1089332295",
      aspectRatio: 16/9,
      tags : [1],
      credits: {
        director: "DONPROD",
        producer: "Lizzie Armanto",
        dop: "Michael Johnson",
        first_ac: "Flynn Dennison",
        second_sc: "Joe Hill",
        gaffer: "London Lighting",
        first_ad: "Benny Goodwin",
        art_director: "Lizzie Armanto",
        socials: "DON Socials",
        photography: "@zanottogiovannii",
        grade: "Mattia Saggiomo",
        sfx: "Kai Goodrem",
        vfx: "Federico Bocchi",
        horse: "Inner City Riderz"
      },
      meta: {
        date: "November 2024",
        runTime: [3, 35],
        location: "Kent",
        coords: ["51.0928° N", "0.8392° W"],
      },
      description: "Yee-haw",
      keywords: ["music video", "uk rap"],
      content: {
        rollingTitle: ["So many fish at sea, but that was Atlantis ","Too many snakes, it's dangerous, too many fakes, it's catfish "],
        splitQuote: ['Took my L\'s in silence','W\'s swiftly pending'],
        minorQuote: ["", ""],
        lastQuote: ['I don\'t get','down like him'],
        heroQuote: ['Pull one back when I tap this bimbo, I feel like Haaland.','- Blanco -']
      },
      thumbnails: {
        placeholder: "../media/main/SOMBRERO/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/SOMBRERO/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/SOMBRERO/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/SOMBRERO/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/SOMBRERO/trim.mp4",
        mobileVideo: "../media/main/SOMBRERO/trim_mobile.mp4"
      },
      tags : [1],
      stills: [
        {
          backgroundImage: "../media/main/SOMBRERO/mobile/SOMBRERO_0.webp",
          placeholder: "../media/main/SOMBRERO/placeholder/SOMBRERO_0.webp"
        },
        {
          backgroundImage: "../media/main/SOMBRERO/mobile/SOMBRERO_1.webp",
          placeholder: "../media/main/SOMBRERO/placeholder/SOMBRERO_1.webp"
        },
        {
          backgroundImage: "../media/main/SOMBRERO/mobile/SOMBRERO_2.webp",
          placeholder: "../media/main/SOMBRERO/placeholder/SOMBRERO_2.webp"
        },
        {
          backgroundImage: "../media/main/SOMBRERO/mobile/SOMBRERO_3.webp",
          placeholder: "../media/main/PACKYSSOMBREROHIVA/placeholder/SOMBRERO_3.webp"
        },
        {
          backgroundImage: "../media/main/SOMBRERO/mobile/SOMBRERO_4.webp",
          placeholder: "../media/main/SOMBRERO/placeholder/SOMBRERO_4.webp"
        }
      ]
    },
    {
      title: "Time Flies",
      artist: "Unknown T",
      feature: null,
      vimeo: "https://vimeo.com/1089337518",
      aspectRatio: 16/9,
      tags : [1],
      credits: {
        director: "DONPROD",
        production: "DONPROD",
        dop: "Michael Johnson",
        first_ac: "Flynn Dennison",
        gaffer: "Jed Clist",
        spark: "Jed Clist",
        editor: "DONPROD",
        grade: "Mattia Saggiomo",
        car: "Diamond Luxury Travel",
        socials: "DON Socials"
      },
      meta: {
        date: "March 2025",
        runTime: [3, 23],
        location: "London",
        coords: ["51.5074° N", "0.1278° W"],
      },
      description: "LISTEN!",
      keywords: ["music video", "uk rap"],
      content: {
        rollingTitle: ["Time flies, havin' fun with foreign badeens, gotta make gyal edit their rota ","This bitch gotta be back to work on a weekday but she loves UK culture "],
        splitQuote: ['I\'m known','but I\'m still unknown'],
        minorQuote: ["", ""],
        lastQuote: ['swipe my card','like poker'],
        heroQuote: ['if I ain\'t got my right hand shooter abroad, I\'ll boot on my own.','- Unknown T -']
      },
      thumbnails: {
        placeholder: "../media/main/TIMEFLIES/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/TIMEFLIES/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/TIMEFLIES/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/TIMEFLIES/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/TIMEFLIES/trim.mp4",
        mobileVideo: "../media/main/TIMEFLIES/trim_mobile.mp4"
      },
      tags : [1],
      stills: [
        {
          backgroundImage: "../media/main/TIMEFLIES/mobile/TIMEFLIES_0.webp",
          placeholder: "../media/main/TIMEFLIES/placeholder/TIMEFLIES_0.webp"
        },
        {
          backgroundImage: "../media/main/TIMEFLIES/mobile/TIMEFLIES_1.webp",
          placeholder: "../media/main/TIMEFLIES/placeholder/TIMEFLIES_1.webp"
        },
        {
          backgroundImage: "../media/main/TIMEFLIES/mobile/TIMEFLIES_2.webp",
          placeholder: "../media/main/TIMEFLIES/placeholder/TIMEFLIES_2.webp"
        },
        {
          backgroundImage: "../media/main/TIMEFLIES/mobile/TIMEFLIES_3.webp",
          placeholder: "../media/main/TIMEFLIES/placeholder/TIMEFLIES_3.webp"
        },
        {
          backgroundImage: "../media/main/TIMEFLIES/mobile/TIMEFLIES_4.webp",
          placeholder: "../media/main/TIMEFLIES/placeholder/TIMEFLIES_4.webp"
        }
      ]
    },
    {
      title: "TAKE WHAT'S YOURS",
      artist: "TWOTONE",
      feature: null,
      vimeo: "https://vimeo.com/1089336924",
      aspectRatio: 4/3,
      tags : [1],
      credits: {
        director: "DONPROD",
        dop: "Din Perlis",
        first_ac: "Polly Coombes",
        creative_director: "Ramsey Ramone",
        production: "DONPROD",
        executive_producer: "Lizzie Armanto",
        producer: "John Fa K",
        gaffer: "Kenneth Liew",
        spark: "Henry Young",
        art_director: "Lizzie Armanto",
        art_assistant: "Elana Katz",
      },
      meta: {
        date: "March 2025",
        runTime: [2, 2],
        location: "London",
        coords: ["51.5074° N", "0.1278° W"],
      },
      description: "LISTEN!",
      keywords: ["music video", "uk rap"],
      content: {
        rollingTitle: ["I DON\'T WANT TO HEAR IT ","I JUST WANNA SNIFF COCAINE "],
        splitQuote: ['Take what\'s yours?','OF COURSE'],
        minorQuote: ["", ""],
        lastQuote: ['DON\'T','GO CLEAN'],
        heroQuote: ['JUST ANOTHER DAY.','- TWOTONE -']
      },
      thumbnails: {
        placeholder: "../media/main/TWOTONE/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/TWOTONE/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/TWOTONE/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/TWOTONE/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/TWOTONE/trim.mp4",
        mobileVideo: "../media/main/TWOTONE/trim_mobile.mp4"
      },
      tags : [1],
      stills: [
        {
          backgroundImage: "../media/main/TWOTONE/mobile/TWOTONE_0.webp",
          placeholder: "../media/main/TWOTONE/placeholder/TWOTONE_0.webp"
        },
        {
          backgroundImage: "../media/main/TWOTONE/mobile/TWOTONE_1.webp",
          placeholder: "../media/main/TWOTONE/placeholder/TWOTONE_1.webp"
        },
        {
          backgroundImage: "../media/main/TWOTONE/mobile/TWOTONE_2.webp",
          placeholder: "../media/main/TWOTONE/placeholder/TWOTONE_2.webp"
        },
        {
          backgroundImage: "../media/main/TWOTONE/mobile/TWOTONE_3.webp",
          placeholder: "../media/main/TWOTONE/placeholder/TWOTONE_3.webp"
        },
        {
          backgroundImage: "../media/main/TWOTONE/mobile/TWOTONE_4.webp",
          placeholder: "../media/main/TWOTONE/placeholder/TWOTONE_4.webp"
        }
      ]
    },
    {
      title: "WHOLE LOTTA",
      artist: "VALIANT",
      feature: null,
      vimeo: "https://vimeo.com/1089337664",
      aspectRatio: 16/9,
      tags : [1],
      credits: {
        director: "DONPROD",
        dop: "Michael Johnson",
        first_ac: "Flynn Dennison",
        second_ac: "Antoine Law",
        first_ad: "Benny Goodwin",
        gaffer: "London Lighting",
        bts: "Alex Alleyne",
        edit: "Hassan Chottara",
        colourist: "Mattia Saggiomo"
      },
      meta: {
        date: "March 2025",
        runTime: [2, 45],
        location: "London",
        coords: ["51.5074° N", "0.1278° W"],
      },
      description: "From JA to the UK",
      keywords: ["music video", "uk rap"],
      content: {
        rollingTitle: ["Money ina air yo me call that helicopter","Chopping up the cars yea them there ina chop shop"],
        splitQuote: ['Ina Louie V','we stepping up'],
        minorQuote: ["", ""],
        lastQuote: ['Whole lotta','Loving'],
        heroQuote: ['Compare me and mi take that as a offense','- Valiant -']
      },
      thumbnails: {
        placeholder: "../media/main/VALLIANT/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/VALLIANT/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/VALLIANT/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/VALLIANT/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/VALLIANT/trim.mp4",
        mobileVideo: "../media/main/VALLIANT/trim_mobile.mp4"
      },
      tags : [1],
      stills: [
        {
          backgroundImage: "../media/main/VALLIANT/mobile/VALLIANT_0.webp",
          placeholder: "../media/main/VALLIANT/placeholder/VALLIANT_0.webp"
        },
        {
          backgroundImage: "../media/main/VALLIANT/mobile/VALLIANT_1.webp",
          placeholder: "../media/main/VALLIANT/placeholder/VALLIANT_1.webp"
        },
        {
          backgroundImage: "../media/main/VALLIANT/mobile/VALLIANT_2.webp",
          placeholder: "../media/main/VALLIANT/placeholder/VALLIANT_2.webp"
        },
        {
          backgroundImage: "../media/main/VALLIANT/mobile/VALLIANT_3.webp",
          placeholder: "../media/main/VALLIANT/placeholder/VALLIANT_3.webp"
        },
        {
          backgroundImage: "../media/main/VALLIANT/mobile/VALLIANT_4.webp",
          placeholder: "../media/main/VALLIANT/placeholder/VALLIANT_4.webp"
        }
      ]
    },
    {
      title: "FIGURA PUBLICA",
      artist: "VEIGH",
      feature: ["NEMZZZ"],
      vimeo: "https://vimeo.com/1089337740",
      aspectRatio: 16/9,
      tags: [1],
      credits: {
        director: "DONPROD",
        producer: "Lizzie Armanto",
        dop: "Michael Johnson",
        first_ac: "Mindaugas Kairys",
        second_ac: "Antoine Law",
        pa: "Polly Coombes",
        pa: "Tea Sophia Small",
        steadicam: "Jake Whitehouse",
        gaffer: "London Lighting",
        edit: "DONPROD",
        colourist: "Ethos Studio",
        titles: "Jost Mess",
        photography: "Ramsey Ramone",
        socials: "DON Socials",
        film_processing: "Kodak",
      },
      meta: {
        date: "March 2025",
        runTime: [2, 18],
        location: "London",
        coords: ["51.5074° N", "0.1278° W"],
      },
      description: "joga bonito in music video form",
      keywords: ["music video", "uk rap"],
      content: {
        rollingTitle: ["Me olha como se eu fosse uma Chanel na vitrinе","Vivendo momentos que parеcem filmes"],
        splitQuote: ['If I didn\'t choose rap','where would I be today?'],
        minorQuote: ["", ""],
        lastQuote: ['It\'s hard','to stay on the low'],
        heroQuote: ['Figura pública, eu não posso andar errado nas ruas.','- VEIGH -']
      },
      thumbnails: {
        placeholder: "../media/main/VEIGH/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/VEIGH/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/VEIGH/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/VEIGH/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/VEIGH/trim.mp4",
        mobileVideo: "../media/main/VEIGH/trim_mobile.mp4"
      },
      tags : [1],
      stills: [
        {
          backgroundImage: "../media/main/VEIGH/mobile/VEIGH_0.webp",
          placeholder: "../media/main/VEIGH/placeholder/VEIGH_0.webp"
        },
        {
          backgroundImage: "../media/main/VEIGH/mobile/VEIGH_1.webp",
          placeholder: "../media/main/VEIGH/placeholder/VEIGH_1.webp"
        },
        {
          backgroundImage: "../media/main/VEIGH/mobile/VEIGH_2.webp",
          placeholder: "../media/main/VEIGH/placeholder/VEIGH_2.webp"
        },
        {
          backgroundImage: "../media/main/VEIGH/mobile/VEIGH_3.webp",
          placeholder: "../media/main/PACKYSVEIGHHIVA/placeholder/VEIGH_3.webp"
        },
        {
          backgroundImage: "../media/main/VEIGH/mobile/VEIGH_4.webp",
          placeholder: "../media/main/VEIGH/placeholder/VEIGH_4.webp"
        }
      ]
    },
    {
      title: "Moi",
      artist: "Central Cee",
      feature: ["Raye"],
      vimeo: "https://vimeo.com/1057120321/62b2077eae",
      aspectRatio: 16/9,
      tags : [1],
      credits: {
        production: "DON PROD",
        director: "DON PROD",
        producer: "Aleksandra Zalesinska",
        dop: "Michael R. Johnson",
        editor: "DON PROD",
        colourist: "Nick Lindell-Wright",
        Development: "Kodak Pinewood",
        Photographer: "Jamie Ramsey",
        first_ac: "Joe Hill",
        first_ad: "Ben Gomm"
      },
      meta: {
        date: "September, 2024",
        runTime: [2, 55],
        location: ["London, UNITED KINGDOM",  "Calais + Paris, FRANCE"],
        coords: null,
      },
      description: "4 day in pARIS, RUN AND GUN, 16MM FILM",
      keywords: ["uk rap", "16mm", "arri sr2"],
      content: {
        rollingTitle: [
          " What would you do in Cee's position? They gave me a fish, they ain't teach me fishing. ",
          " Back in the day, I had decent bitches. But they ain't got nothin' on my recent women. "
        ],
        splitQuote: [
          'BACK IN THE DAY',
          'I HAD DECENT'
        ],
        minorQuote: [
          "GOOD BOY", 
          "'TILL I STARTED SINNIN'"
        ],
        lastQuote: [
          'Je pense',
          'à toi'
        ],
        heroQuote: [
          'Talk about drill, gotta mention moi.',
          '-Cee-'
        ]
      },
      thumbnails: {
        placeholder: "../media/main/MOI/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/MOI/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/MOI/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/MOI/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/MOI/trim.mp4",
        mobileVideo: "../media/main/MOI/trim_mobile.mp4"
      },
      tags : [1],
      stills: [
        {
          backgroundImage: "../media/main/MOI/mobile/MOI_0.webp",
          placeholder: "../media/main/MOI/placeholder/MOI_0.webp"
        },
        {
          backgroundImage: "../media/main/MOI/mobile/MOI_1.webp",
          placeholder: "../media/main/MOI/placeholder/MOI_1.webp"
        },
        {
          backgroundImage: "../media/main/MOI/mobile/MOI_2.webp",
          placeholder: "../media/main/MOI/placeholder/MOI_2.webp"
        },
        {
          backgroundImage: "../media/main/MOI/mobile/MOI_3.webp",
          placeholder: "../media/main/MOI/placeholder/MOI_3.webp"
        },
        {
          backgroundImage: "../media/main/MOI/mobile/MOI_4.webp",
          placeholder: "../media/main/MOI/placeholder/MOI_4.webp"
        },
        {
          backgroundImage: "../media/main/MOI/mobile/MOI_5.webp",
          placeholder: "../media/main/MOI/placeholder/MOI_5.webp"
        },
        {
          backgroundImage: "../media/main/MOI/mobile/MOI_6.webp",
          placeholder: "../media/main/MOI/placeholder/MOI_6.webp"
        },
        {
          backgroundImage: "../media/main/MOI/mobile/MOI_7.webp",
          placeholder: "../media/main/MOI/placeholder/MOI_7.webp"
        }
      ]
    },
    // {
    //   title: "Kindness For Weakness",
    //   artist: "Digga D",
    //   feature: ["Raye"],
    //   vimeo: "https://vimeo.com/1057120633/7433f11b60",
    //   aspectRatio: 16/9,
    //   tags : [1],
    //   credits: {
    //     director: "DON PROD",
    //     producer: "Adam Watts",
    //     first_ad: "Jahn Ramis",
    //     first_ac: "Mindaugas Kairys",
    //     dop: "Michael R. Johnson",
    //     editor: "Samuel Maton",
    //     photographer: "Ollie Buckle"
    //   },
    //   meta: {
    //     date: "August, 2023",
    //     runTime: [2, 43],
    //     location: "Castle Gibson, London",
    //     coords: ["51.5452° N", "0.0749° W"],
    //   },
    //   description: "A reflection of Digga's achievements. ",
    //   keywords: ["uk rap", "arri alexa"],
    //   content: {
    //     rollingTitle: [
    //       " N***as take my kindness for weakness. ",
    //       " I see their weakness, but they're showin' me in kindness. ",
    //     ],
    //     splitQuote: [
    //       'BELIEVE IN MYSELF',
    //       'KNOW I\'M ABLE'
    //     ],
    //     minorQuote: [
    //       "No backbone.", 
    //       "N***AS spineless"
    //     ],
    //     lastQuote: [
    //       'FULLY,',
    //       'FULLY UP'
    //     ],
    //     heroQuote: [
    //       'Fuck beggin\' for a seat, I\'ma build my own table',
    //       '- Digga D -'
    //     ]
    //   },
    //   thumbnails: {
    //     placeholder: "../media/main/KINDNESSFORWEAKNESS/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
    //     mobile: "../media/main/KINDNESSFORWEAKNESS/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
    //     laptop: "../media/main/KINDNESSFORWEAKNESS/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
    //     desktop: "../media/main/KINDNESSFORWEAKNESS/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
    //   },
    //   gifStyling: {
    //     backgroundImage: "../media/main/KINDNESSFORWEAKNESS/trim.mp4",
    //     mobileVideo: "../media/main/KINDNESSFORWEAKNESS/trim_mobile.mp4"
    //   },
    //   tags : [1],
    //   stills: [
    //     {
    //       backgroundImage: "../media/main/KINDNESSFORWEAKNESS/mobile/KINDNESSFORWEAKNESS_0.webp",
    //       placeholder: "../media/main/KINDNESSFORWEAKNESS/placeholder/KINDNESSFORWEAKNESS_0.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/KINDNESSFORWEAKNESS/mobile/KINDNESSFORWEAKNESS_1.webp",
    //       placeholder: "../media/main/KINDNESSFORWEAKNESS/placeholder/KINDNESSFORWEAKNESS_1.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/KINDNESSFORWEAKNESS/mobile/KINDNESSFORWEAKNESS_2.webp",
    //       placeholder: "../media/main/KINDNESSFORWEAKNESS/placeholder/KINDNESSFORWEAKNESS_2.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/KINDNESSFORWEAKNESS/mobile/KINDNESSFORWEAKNESS_3.webp",
    //       placeholder: "../media/main/KINDNESSFORWEAKNESS/placeholder/KINDNESSFORWEAKNESS_3.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/KINDNESSFORWEAKNESS/mobile/KINDNESSFORWEAKNESS_4.webp",
    //       placeholder: "../media/main/KINDNESSFORWEAKNESS/placeholder/KINDNESSFORWEAKNESS_4.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/KINDNESSFORWEAKNESS/mobile/KINDNESSFORWEAKNESS_5.webp",
    //       placeholder: "../media/main/KINDNESSFORWEAKNESS/placeholder/KINDNESSFORWEAKNESS_5.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/KINDNESSFORWEAKNESS/mobile/KINDNESSFORWEAKNESS_6.webp",
    //       placeholder: "../media/main/KINDNESSFORWEAKNESS/placeholder/KINDNESSFORWEAKNESS_6.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/KINDNESSFORWEAKNESS/mobile/KINDNESSFORWEAKNESS_7.webp",
    //       placeholder: "../media/main/KINDNESSFORWEAKNESS/placeholder/KINDNESSFORWEAKNESS_7.webp"
    //     }
    //   ]
    // },
    // {
    //   title: "Quarter Past 3",
    //   artist: "Fredo",
    //   feature: "Eric IV",
    //   vimeo: "MISSING", //MISSING
    //   aspectRatio: 16/9,
    //   tags : [1, 4],
    //   credits: {
    //     director: "DON PROD",
    //     executiveProducer: "Teoman Han",
    //     producer: "Alex Alleyne",
    //     gaffer: "Qwase Anderson",
    //     spark: "Kenny Holder",
    //     colourProducer: "George Blomiley",
    //     colourist: "Alexandre Nerzic",
    //     photographer: "Alex Alleyne"
    //   },
    //   meta: {
    //     runTime: ["MISSING"], // MISSING
    //     coords: ["13.1939° N", "59.5432° W"],
    //     location: "London + Barbados"
    //   },
    //   content: {
    //     rollingTitle: [
    //       " When they ask for you number on the side of the street. ",
    //       " Tell them guys, that you're ridin' with me. ",
    //     ],
    //     splitQuote: [
    //       'Placin\' the blame',
    //       'I just take it again'
    //     ],
    //     minorQuote: [
    //       "JUST TRYNA", 
    //       "SET YOU FREE"
    //     ],
    //     lastQuote: [
    //       'IS YOU REALLY',
    //       'ALL I NEED?'
    //     ],
    //     heroQuote: [
    //       'Tell me what you need, baby girl, it\'s on me',
    //       '- Fredo -'
    //     ]
    //   },
    //   thumbnails: {
    //     placeholder: "../media/main/QUARTERPAST/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
    //     mobile: "../media/main/QUARTERPAST/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
    //     laptop: "../media/main/QUARTERPAST/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
    //     desktop: "../media/main/QUARTERPAST/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
    //   },
    //   gifStyling: {
    //     backgroundImage: "../media/main/QUARTERPAST/trim.mp4" // The gif used for the thumbnail
    //   },
    //   tags : [1],
    //   stills: [
    //     {
    //       backgroundImage: "../media/main/QUARTERPAST/mobile/QUARTERPAST_0.webp",
    //       placeholder: "../media/main/QUARTERPAST/placeholder/QUARTERPAST_0.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/QUARTERPAST/mobile/QUARTERPAST_1.webp",
    //       placeholder: "../media/main/QUARTERPAST/placeholder/QUARTERPAST_1.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/QUARTERPAST/mobile/QUARTERPAST_2.webp",
    //       placeholder: "../media/main/QUARTERPAST/placeholder/QUARTERPAST_2.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/QUARTERPAST/mobile/QUARTERPAST_3.webp",
    //       placeholder: "../media/main/QUARTERPAST/placeholder/QUARTERPAST_3.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/QUARTERPAST/mobile/QUARTERPAST_4.webp",
    //       placeholder: "../media/main/QUARTERPAST/placeholder/QUARTERPAST_4.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/QUARTERPAST/mobile/QUARTERPAST_5.webp",
    //       placeholder: "../media/main/QUARTERPAST/placeholder/QUARTERPAST_5.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/QUARTERPAST/mobile/QUARTERPAST_6.webp",
    //       placeholder: "../media/main/QUARTERPAST/placeholder/QUARTERPAST_6.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/QUARTERPAST/mobile/QUARTERPAST_7.webp",
    //       placeholder: "../media/main/QUARTERPAST/placeholder/QUARTERPAST_7.webp"
    //     }
    //   ]
    // },
    // {
    //   title: "ILLEGAL",
    //   artist: "Headie One",
    //   feature: null,
    //   vimeo: "https://vimeo.com/1057121115/30ece6bb80", 
    //   aspectRatio: 16/9,
    //   tags : [1],
    //   credits: {
    //     director: "DON PROD",
    //     producer: "Adam Watts",
    //     dop: "Michael R. Johnson",
    //     first_ac: "Mindaugas Kairys",
    //     bts: "Jamie Ramsey",
    //     pa: "Lucy Chappell",
    //     pa: "Daisy White"
    //   },
    //   meta: {
    //     date: "August 2022",
    //     runTime: [3, 39], 
    //     location: "Ramsgate, London",
    //     coords: ["",""],
    //     date: "Summer 24",
    //   },
    //   description: "Parrots, helicopters and supercars. All in red.",
    //   keywords: ["music video", "uk drill", "arri alexa"],
    //   content: {
    //     rollingTitle: [
    //       " Still outside, no face, no case.",
    //       " 'cah they still say my name, and bros caught case."
    //     ],
    //     splitQuote: [
    //       ' I\'m legal handlin\'',
    //       'Shit Illegal'
    //     ],
    //     minorQuote: [
    //       "Wrist so wet", 
    //       "Lookin\' like a sea view"
    //     ],
    //     lastQuote: [
    //       'Am I legal,',
    //       'Or ILLEGAL?'
    //     ],
    //     heroQuote: [
    //       'It\'s still PTSD when I hear that nina.',
    //       '- HEADIE ONE -'
    //     ]
    //   },
    //   thumbnails: {
    //     placeholder: "../media/main/HEADIE/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
    //     mobile: "../media/main/HEADIE/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
    //     laptop: "../media/main/HEADIE/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
    //     desktop: "../media/main/HEADIE/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
    //   },
    //   gifStyling: {
    //     backgroundImage: "../media/main/HEADIE/trim.mp4",
    //     mobileVideo: "../media/main/HEADIE/trim_mobile.mp4"
    //   },
    //   stills: [
    //     {
    //       backgroundImage: "../media/main/HEADIE/mobile/ILLEGAL_0.webp",
    //       placeholder: "../media/main/HEADIE/placeholder/ILLEGAL_0.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/HEADIE/mobile/ILLEGAL_1.webp",
    //       placeholder: "../media/main/HEADIE/placeholder/ILLEGAL_1.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/HEADIE/mobile/ILLEGAL_2.webp",
    //       placeholder: "../media/main/HEADIE/placeholder/ILLEGAL_2.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/HEADIE/mobile/ILLEGAL_3.webp",
    //       placeholder: "../media/main/HEADIE/placeholder/ILLEGAL_3.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/HEADIE/mobile/ILLEGAL_4.webp",
    //       placeholder: "../media/main/HEADIE/placeholder/ILLEGAL_4.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/HEADIE/mobile/ILLEGAL_5.webp",
    //       placeholder: "../media/main/HEADIE/placeholder/ILLEGAL_5.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/HEADIE/mobile/ILLEGAL_6.webp",
    //       placeholder: "../media/main/HEADIE/placeholder/ILLEGAL_6.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/HEADIE/mobile/ILLEGAL_7.webp",
    //       placeholder: "../media/main/HEADIE/placeholder/ILLEGAL_7.webp"
    //     }
    //   ]
    // },
    {
      title: "Tipsy",
      artist: "Headie One",
      feature: ["Aitch"],
      vimeo: "https://vimeo.com/1057125438/ba4aa3b1e4", 
      aspectRatio: 16/9,
      tags : [1],
      credits: {
        director: "DON PROD",
        dop: "Michael R. Johnson",
        producer: "Jahn Ramis",
        producer: "Quinn Titsworth",
        commissioner: "Quinn Titsworth",
        editor: "DON PROD",
        colourist: "Loren James White"
      },
      meta: {
        date: "June 2021",
        runTime: [2, 49], 
        location: "Marbella, Spain",
        coords: ["36.5103° N", "4.8853° W"],
      },
      description: "Summer vibes on 16mm in Marbella. ",
      keywords: ["music video", "uk rap", "arri sr2"],
      content: {
        rollingTitle: [
          " Still outside, no face, no case.",
          " 'cah they still say my name, and bros caught case."
        ],
        splitQuote: [
           " Toxic relations.",
            "In custom 'til they freed her."
        ],
        minorQuote: [
          "I guarantee", 
          "I leave shawty curled up"
        ],
        lastQuote: [
          'HONEY',
          'GOT ME TIPSY'
        ],
        heroQuote: [
          'I sip rum, I guarantee I leave shawty curled up.',
          '- HEADIE ONE -'
        ]
      },
      thumbnails: {
        placeholder: "../media/main/TIPSY/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/TIPSY/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/TIPSY/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/TIPSY/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/TIPSY/trim.mp4",
        mobileVideo: "../media/main/TIPSY/trim_mobile.mp4"
      },
      stills: [
        {
          backgroundImage: "../media/main/TIPSY/mobile/TIPSY_0.webp",
          placeholder: "../media/main/TIPSY/placeholder/TIPSY_0.webp"
        },
        {
          backgroundImage: "../media/main/TIPSY/mobile/TIPSY_1.webp",
          placeholder: "../media/main/TIPSY/placeholder/TIPSY_1.webp"
        },
        {
          backgroundImage: "../media/main/TIPSY/mobile/TIPSY_2.webp",
          placeholder: "../media/main/TIPSY/placeholder/TIPSY_2.webp"
        },
        {
          backgroundImage: "../media/main/TIPSY/mobile/TIPSY_3.webp",
          placeholder: "../media/main/TIPSY/placeholder/TIPSY_3.webp"
        },
        {
          backgroundImage: "../media/main/TIPSY/mobile/TIPSY_4.webp",
          placeholder: "../media/main/TIPSY/placeholder/TIPSY_4.webp"
        },
        {
          backgroundImage: "../media/main/TIPSY/mobile/TIPSY_5.webp",
          placeholder: "../media/main/TIPSY/placeholder/TIPSY_5.webp"
        },
        {
          backgroundImage: "../media/main/TIPSY/mobile/TIPSY_6.webp",
          placeholder: "../media/main/TIPSY/placeholder/TIPSY_6.webp"
        },
        {
          backgroundImage: "../media/main/TIPSY/mobile/TIPSY_7.webp",
          placeholder: "../media/main/TIPSY/placeholder/TIPSY_7.webp"
        }
      ]
    },
    // {
    //   title: "Dat Way",
    //   artist: "Krept & Konan",
    //   feature: null,
    //   vimeo: "https://vimeo.com/1057126093/fbad1d09b6", 
    //   aspectRatio: 16/9,
    //   tags : [1],
    //   credits: {
    //     director: "DON PROD",
    //     producer: "Adam Watts",
    //     first_ad: "Jahn Ramis",
    //     dop: "Michael R. Johnson",
    //     first_ac: "Fabio Olgiati",
    //     trainee: "Abhishek Thapa",
    //     steadicam: "Lee David Brown",
    //     gaffer: "Sachin Parma",
    //     spark: "Mazin",
    //     photography: "Jamie Ramsey",
    //     photography: "Thomas Morgan"
    //   },
    //   meta: {
    //     date: "February 2023",
    //     runTime: [4, 12], 
    //     location: "London, UK",
    //     coords: ["51.5072° N", "0.1276° W"],
    //   },
    //   description: "16mm + the block = cheat code",
    //   keywords: ["16MM", "uk drill", "arri sr2"],
    //   content: {
    //       rollingTitle: [
    //         " I'm in, then I'm out, like I fucked mans girl.",
    //         " I'm in, then I'm out, when I press this ting."
    //       ],
    //       splitQuote: [
    //         'Are You Paid?',
    //         'Of Course.'
    //       ],
    //       minorQuote: [
    //         "Bad man", 
    //         "With a good heart"
    //       ],
    //       lastQuote: [
    //         'IM IN THEN,',
    //         'IM OUT.'
    //       ],
    //       heroQuote: [
    //         'Fuck who you listenin\' to',
    //         '- K&K -'
    //       ]
    //   },
    //   thumbnails: {
    //     placeholder: "../media/main/DATWAYKREPT/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
    //     mobile: "../media/main/DATWAYKREPT/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
    //     laptop: "../media/main/DATWAYKREPT/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
    //     desktop: "../media/main/DATWAYKREPT/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
    //   },
    //   gifStyling: {
    //     backgroundImage: "../media/main/DATWAYKREPT/trim.mp4",
    //     mobileVideo: "../media/main/DATWAYKREPT/trim_mobile.mp4"
    //   },
    //   stills: [
    //     {
    //       backgroundImage: "../media/main/DATWAYKREPT/mobile/DATWAY_0.webp",
    //       placeholder: "../media/main/DATWAYKREPT/placeholder/DATWAY_0.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/DATWAYKREPT/mobile/DATWAY_1.webp",
    //       placeholder: "../media/main/DATWAYKREPT/placeholder/DATWAY_1.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/DATWAYKREPT/mobile/DATWAY_2.webp",
    //       placeholder: "../media/main/DATWAYKREPT/placeholder/DATWAY_2.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/DATWAYKREPT/mobile/DATWAY_3.webp",
    //       placeholder: "../media/main/DATWAYKREPT/placeholder/DATWAY_3.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/DATWAYKREPT/mobile/DATWAY_4.webp",
    //       placeholder: "../media/main/DATWAYKREPT/placeholder/DATWAY_4.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/DATWAYKREPT/mobile/DATWAY_5.webp",
    //       placeholder: "../media/main/DATWAYKREPT/placeholder/DATWAY_5.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/DATWAYKREPT/mobile/DATWAY_6.webp",
    //       placeholder: "../media/main/DATWAYKREPT/placeholder/DATWAY_6.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/DATWAYKREPT/mobile/DATWAY_7.webp",
    //       placeholder: "../media/main/DATWAYKREPT/placeholder/DATWAY_7.webp"
    //     }
    //   ]
    // },
    {
      title: "I Know",
      artist: "LeoStayTrill",
      feature: ["Jay Baloo", "Ade STP"],
      vimeo: "https://vimeo.com/1057126487/c00a291129", 
      aspectRatio: 4/3,
      tags : [1],
      credits: {
        director: "DON PROD",
        dop: "Michael R. Johnson",
        second_AC: "Antione Law",
        gaffer: "London Lighting",
        continuity: "Polly Coombes",
        graphics: "Harry Clean",
        VFX: "Federico Bocchi"
      },
      meta: {
        date: "April 2024",
        runTime: [2, 15], 
        location: "London, UK",
        coords: ["51.5072° N", "0.1276° W"],
      },
      description: "Experimenting with film. ",
      keywords: ["FILM", "Experimental", "vfx"],
      content: {
        rollingTitle: [
          " The badder make pounds, I know, I know.",
          " Tell her bend down, how low, how low?"
        ],
        splitQuote: [
          'On her Insta',
          'Unfollowing now'
        ],
        minorQuote: [
          "How low?", 
          "How low?"
        ],
        lastQuote: [
          'king of',
          'my hood'
        ],
        heroQuote: [
          'You talk Ps, but I heard that you cap.',
          '- Leo -'
        ]
      },
      thumbnails: {
        placeholder: "../media/main/IKNOW/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/IKNOW/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/IKNOW/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/IKNOW/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/IKNOW/trim.mp4",
        mobileVideo: "../media/main/IKNOW/trim_mobile.mp4"
      },
      stills: [
        {
          backgroundImage: "../media/main/IKNOW/mobile/IKNOW_0.webp",
          placeholder: "../media/main/IKNOW/placeholder/IKNOW_0.webp"
        },
        
        {
          backgroundImage: "../media/main/IKNOW/mobile/IKNOW_2.webp",
          placeholder: "../media/main/IKNOW/placeholder/IKNOW_2.webp"
        },
        {
          backgroundImage: "../media/main/IKNOW/mobile/IKNOW_1.webp",
          placeholder: "../media/main/IKNOW/placeholder/IKNOW_1.webp"
        },
        {
          backgroundImage: "../media/main/IKNOW/mobile/IKNOW_3.webp",
          placeholder: "../media/main/IKNOW/placeholder/IKNOW_3.webp"
        },
        {
          backgroundImage: "../media/main/IKNOW/mobile/IKNOW_4.webp",
          placeholder: "../media/main/IKNOW/placeholder/IKNOW_4.webp"
        },
        {
          backgroundImage: "../media/main/IKNOW/mobile/IKNOW_5.webp",
          placeholder: "../media/main/IKNOW/placeholder/IKNOW_5.webp"
        },
        {
          backgroundImage: "../media/main/IKNOW/mobile/IKNOW_6.webp",
          placeholder: "../media/main/IKNOW/placeholder/IKNOW_6.webp"
        },
        {
          backgroundImage: "../media/main/IKNOW/mobile/IKNOW_7.webp",
          placeholder: "../media/main/IKNOW/placeholder/IKNOW_7.webp"
        }
      ]
    },
    // {
    //   title: "Escape",
    //   artist: "Nemzzz",
    //   feature: null,
    //   vimeo: "https://vimeo.com/1057132558/675fc79b7c", 
    //   aspectRatio: 80/53,
    //   tags : [1],
    //   credits: {
    //     director: "DON PROD",
    //     dop: "Michael R. Johnson",
    //     photography: "Jamie Ramsey",
    //     gaffer: "London Lighting",
    //     first_ac: "Mindaugas Kairys",
    //     second_ac: "Antoine Law",
    //     colour_house: "Creative Outpost",
    //     colourist: "Alexandre Nerzic",
    //     sound_design: "Kai Goodrem"
    //   },
    //   meta: {
    //     date: "July 2024",
    //     runTime: [2, 8], 
    //     location: "London, UK",
    //     coords: ["51.5072", "0.1276° W"],
    //   },
    //   description: "Shot, edited and released in under 48 hours.",
    //   keywords: ["LIVE", "uk rap", "arri alexa"],
    //   content: {
    //     rollingTitle: [
    //       " What is it now? I stood on business and I made it clear.",
    //       " I'm over it now, you done all this to make me look weird."
    //     ],
    //     splitQuote: [
    //       'If it\'s you or me',
    //       'that\'s peak on you'
    //     ],
    //     minorQuote: [
    //       "Speak w chest", 
    //       "no need to shout"
    //     ],
    //     lastQuote: [
    //       'just mad',
    //       'you\'re broke'
    //     ],
    //     heroQuote: [
    //       'So many questions, who do I ask? Where do I go from here?',
    //       '- Nemzzz -'
    //     ]
    //   },
    //   thumbnails: {
    //     placeholder: "../media/main/ESCAPE/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
    //     mobile: "../media/main/ESCAPE/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
    //     laptop: "../media/main/ESCAPE/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
    //     desktop: "../media/main/ESCAPE/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
    //   },
    //   gifStyling: {
    //     backgroundImage: "../media/main/ESCAPE/trim.mp4",
    //     mobileVideo: "../media/main/ESCAPE/trim_mobile.mp4"
    //   },
    //   stills: [
    //     {
    //       backgroundImage: "../media/main/ESCAPE/mobile/ESCAPE_0.webp",
    //       placeholder: "../media/main/ESCAPE/placeholder/ESCAPE_0.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/ESCAPE/mobile/ESCAPE_1.webp",
    //       placeholder: "../media/main/ESCAPE/placeholder/ESCAPE_1.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/ESCAPE/mobile/ESCAPE_2.webp",
    //       placeholder: "../media/main/ESCAPE/placeholder/ESCAPE_2.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/ESCAPE/mobile/ESCAPE_3.webp",
    //       placeholder: "../media/main/ESCAPE/placeholder/ESCAPE_3.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/ESCAPE/mobile/ESCAPE_4.webp",
    //       placeholder: "../media/main/ESCAPE/placeholder/ESCAPE_4.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/ESCAPE/mobile/ESCAPE_5.webp",
    //       placeholder: "../media/main/ESCAPE/placeholder/ESCAPE_5.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/ESCAPE/mobile/ESCAPE_6.webp",
    //       placeholder: "../media/main/ESCAPE/placeholder/ESCAPE_6.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/ESCAPE/mobile/ESCAPE_7.webp",
    //       placeholder: "../media/main/ESCAPE/placeholder/ESCAPE_7.webp"
    //     }
    //   ]
    // },
    {
      title: "L's",
      artist: "Nemzzz",
      feature: null,
      vimeo: "https://vimeo.com/1057621823/0ec385a816", 
      aspectRatio: 16/9,
      tags : [1],
      credits: {
        director: "DON PROD",
        dop: "Michael R. Johnson",
        first_ac: "Christian Wood",
        first_ac: "Mindaugas Kairys",
        Gaffer: "London Lighting",
        second_ac: "Antione Law",
        photography: "Jamie Ramsey",
        editor: "Georgie Curran",
        colourist: "Jared Rosenthal",
        titles: "Coi Tran",
        film_processing: "Kodak"
      },
      meta: {
        date: "February 2024",
        runTime: [2, 1], 
        location: "London, UK",
        coords: ["51.5072", "0.1276° W"],
      },
      description: "One of our personal favourites for Nemzzz. ",
      keywords: ["music video", "uk rap", "arri sr 2"],
      content: {
        rollingTitle: [
          " What is it now? I stood on business and I made it clear.",
          " I'm over it now, you done all this to make me look weird."
        ],
        splitQuote: [
          'Better than who?',
          'Better than me?'
        ],
        minorQuote: [
          'FUCK MY EX',
          'FUCK MY EX'
          
        ],
        lastQuote: [
          "My L's come", "with a V"
        ],
        heroQuote: [
          'So many parties missed, now I can sip my cognac.',
          '- Nemzzz -'
        ]
      },
      thumbnails: {
        placeholder: "../media/main/LS/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/LS/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/LS/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/LS/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/LS/trim.mp4",
        mobileVideo: "../media/main/LS/trim_mobile.mp4"
      },
      stills: [
        {
          backgroundImage: "../media/main/LS/mobile/LS_1.webp",
          placeholder: "../media/main/LS/placeholder/LS_1.webp"
        },
        {
          backgroundImage: "../media/main/LS/mobile/LS_2.webp",
          placeholder: "../media/main/LS/placeholder/LS_2.webp"
        },
        {
          backgroundImage: "../media/main/LS/mobile/LS_3.webp",
          placeholder: "../media/main/LS/placeholder/LS_3.webp"
        },
        {
          backgroundImage: "../media/main/LS/mobile/LS_4.webp",
          placeholder: "../media/main/LS/placeholder/LS_4.webp"
        },
        {
          backgroundImage: "../media/main/LS/mobile/LS_5.webp",
          placeholder: "../media/main/LS/placeholder/LS_5.webp"
        },
        {
          backgroundImage: "../media/main/LS/mobile/LS_6.webp",
          placeholder: "../media/main/LS/placeholder/LS_6.webp"
        },
        {
          backgroundImage: "../media/main/LS/mobile/LS_0.webp",
          placeholder: "../media/main/LS/placeholder/LS_0.webp"
        },
        {
          backgroundImage: "../media/main/LS/mobile/LS_7.webp",
          placeholder: "../media/main/LS/placeholder/LS_7.webp"
        },
      ]
    },
    {
      title: "Its Us",
      artist: "Nemzzz",
      feature: ["Lil Yachty"],
      vimeo: "https://vimeo.com/1057132843/27b61b505d", 
      aspectRatio: 16/9,
      tags : [1],
      credits: {
        director: "DON PROD",
        dop: "Michael R. Johnson",
        first_ac: "Mindaugas Kairys",
        second_ac: "Rory Thomas",
        Gaffer: "London Lighting",
        photography: "Jamie Ramsey",
        sound_design: "Kai Goodrem",
        title: "Sam Bellinger"
      },
      meta: {
        date: "March 2024",
        runTime: [1, 58], 
        location: "London, UK",
        coords: ["51.5072", "0.1276° W"],
      },
      description: "Big UK x US linkup. Lil Boat on a boat.",
      keywords: ["music video", "uk rap", "arri sr2", "vfx"],
      content: {
        rollingTitle: [
          " I just told bro, It's us. I hit that one, no fuss.",
          " I hit that one, then cut, ay, skrrt, I'm in a rush."
        ],
        splitQuote: [
          'TIRED OF THESE HOES',
          'I NEED YOUR LOVE'
        ],
        minorQuote: [
          'MY HATERS',
          'I WISH YOU WELL'
          
        ],
        lastQuote: [
          "I TOLD BRO,", "IT\'s US."
        ],
        heroQuote: [
          'All my opps still broke? Oh my God, what a bummer.',
          '- Yachty -'
        ]
      },
      thumbnails: {
        placeholder: "../media/main/ITSUS/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/ITSUS/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/ITSUS/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/ITSUS/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/ITSUS/trim.mp4",
        mobileVideo: "../media/main/ITSUS/trim_mobile.mp4"
      },
      stills: [
        {
          backgroundImage: "../media/main/ITSUS/mobile/ITSUS_4.webp",
          placeholder: "../media/main/ITSUS/placeholder/ITSUS_4.webp"
        },
        {
          backgroundImage: "../media/main/ITSUS/mobile/ITSUS_7.webp",
          placeholder: "../media/main/ITSUS/placeholder/ITSUS_7.webp"
        },
        {
          backgroundImage: "../media/main/ITSUS/mobile/ITSUS_0.webp",
          placeholder: "../media/main/ITSUS/placeholder/ITSUS_0.webp"
        },
        {
          backgroundImage: "../media/main/ITSUS/mobile/ITSUS_2.webp",
          placeholder: "../media/main/ITSUS/placeholder/ITSUS_2.webp"
        },
        {
          backgroundImage: "../media/main/ITSUS/mobile/ITSUS_3.webp",
          placeholder: "../media/main/ITSUS/placeholder/ITSUS_3.webp"
        },
        
        {
          backgroundImage: "../media/main/ITSUS/mobile/ITSUS_6.webp",
          placeholder: "../media/main/ITSUS/placeholder/ITSUS_6.webp"
        },
        
        {
          backgroundImage: "../media/main/ITSUS/mobile/ITSUS_1.webp",
          placeholder: "../media/main/ITSUS/placeholder/ITSUS_1.webp"
        },
        {
          backgroundImage: "../media/main/ITSUS/mobile/ITSUS_5.webp",
          placeholder: "../media/main/ITSUS/placeholder/ITSUS_5.webp"
        }
      ]
    },
    {
      title: "PTSD",
      artist: "Nemzzz",
      feature: null,
      vimeo: "https://vimeo.com/1057133036/d25e03544e", 
      aspectRatio: 80/53, //MISSING
      tags : [1],
      credits: {
        director: "DON PROD",
        dop: "Michael R. Johnson",
        first_ac: "Ken Carson",
        photography: "Jamie Ramsey",
        editor: "Georgie Curran",
        graphics: "Coi Tran",
        sound_design: "Kai Goodrem",
        dogs: "Hazeline"
      },
      meta: {
        date: "February 2024",
        runTime: [2, 15], 
        coords: ["53.4808° N", "2.2426° W"],
        location: "Manchester, UK",
      },
      description: "Multimedia masterpiece.",
      keywords: ["music video", "uk rap", "arri alexa", "vfx"],
      content: {
        rollingTitle: [
          " Overthink too much, I get distracted, start to deep it.",
          " me, I just deal with people exactly how they treat me."
        ],
        splitQuote: [
          'I know that I hurt',
          'I cut you off'
        ],
        minorQuote: [
          'Stay in my bag',
          'not in my feelings'
          
        ],
        lastQuote: [
          "GET OUT", "the way"
        ],
        heroQuote: [
          'No one checked on me when I needed.',
          '- Nemzzz -'
        ]
      },
      thumbnails: {
        placeholder: "../media/main/PTSD/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/PTSD/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/PTSD/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/PTSD/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/PTSD/trim.mp4",
        mobileVideo: "../media/main/PTSD/trim_mobile.mp4"
      },
      stills: [
        
        {
          backgroundImage: "../media/main/PTSD/mobile/PTSD_1.webp",
          placeholder: "../media/main/PTSD/placeholder/PTSD_1.webp"
        },{
          backgroundImage: "../media/main/PTSD/mobile/PTSD_0.webp",
          placeholder: "../media/main/PTSD/placeholder/PTSD_0.webp"
        },
        {
          backgroundImage: "../media/main/PTSD/mobile/PTSD_2.webp",
          placeholder: "../media/main/PTSD/placeholder/PTSD_2.webp"
        },
        {
          backgroundImage: "../media/main/PTSD/mobile/PTSD_3.webp",
          placeholder: "../media/main/PTSD/placeholder/PTSD_3.webp"
        },
        {
          backgroundImage: "../media/main/PTSD/mobile/PTSD_4.webp",
          placeholder: "../media/main/PTSD/placeholder/PTSD_4.webp"
        },
        {
          backgroundImage: "../media/main/PTSD/mobile/PTSD_5.webp",
          placeholder: "../media/main/PTSD/placeholder/PTSD_5.webp"
        },
        {
          backgroundImage: "../media/main/PTSD/mobile/PTSD_6.webp",
          placeholder: "../media/main/PTSD/placeholder/PTSD_6.webp"
        },
        {
          backgroundImage: "../media/main/PTSD/mobile/PTSD_7.webp",
          placeholder: "../media/main/PTSD/placeholder/PTSD_7.webp"
        }
      ]
      
    },
    // {
    //   title: "RUNTZ",
    //   artist: "Smokes",
    //   feature: null,
    //   vimeo: "https://vimeo.com/1057133184/5c0f1a692a", 
    //   aspectRatio: 4/3,
    //   tags : [1],
    //   credits: {
    //     director: "DON PROD",
    //     dop: "Michael R. Johnson",
    //     first_ac: "Mindaugas Kairys",
    //     gaffer: "Sachin Parma",
    //     warehouse: "London Lighting",
    //     vfx: "Federico Bocchi",
    //     titles: "Archie Griffifths"
    //   },
    //   meta: {
    //     date: "January 2023",
    //     runTime: [3, 23], 
    //     coords: ["51.5072", "0.1276° W"],
    //     location: "London, UK",
    //   },
    //   description: "VFX bonanza.",
    //   keywords: ["music video", "uk drill", "arri alexa", "vfx"],
    //   content: {
    //     rollingTitle: [
    //       " TURN UP AT YOUR BLOCK FOR THE LITTLEST THINGS.",
    //       " I DONT CARE WHAT YOU LIFT IN THE GYM. THESE HOLLOWS WILL TEAR OUT HIS RIMS."
    //     ],
    //     splitQuote: [
    //       'ALWAYS ON VIOLENCE',
    //       'NEVER ON CHATTINGS'
    //     ],
    //     minorQuote: [
    //       'TWENTY THREE',
    //       'AND I RUN MY BLOCK'
          
    //     ],
    //     lastQuote: [
    //       "REAL LIFE", "GANG TIES"
    //     ],
    //     heroQuote: [
    //       'I\'M A DANGEROUS YUTE, YOU CAN CHECK MY CREDENTIALS.',
    //       '- Smokes -'
    //     ]
    //   },
    //   thumbnails: {
    //     placeholder: "../media/main/RUNTZ/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
    //     mobile: "../media/main/RUNTZ/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
    //     laptop: "../media/main/RUNTZ/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
    //     desktop: "../media/main/RUNTZ/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
    //   },
    //   gifStyling: {
    //     backgroundImage: "../media/main/RUNTZ/trim.mp4",
    //     mobileVideo: "../media/main/RUNTZ/trim_mobile.mp4"
    //   },
    //   stills: [
    //     {
    //       backgroundImage: "../media/main/RUNTZ/mobile/RUNTZ_0.webp",
    //       placeholder: "../media/main/RUNTZ/placeholder/RUNTZ_0.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/RUNTZ/mobile/RUNTZ_7.webp",
    //       placeholder: "../media/main/RUNTZ/placeholder/RUNTZ_7.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/RUNTZ/mobile/RUNTZ_2.webp",
    //       placeholder: "../media/main/RUNTZ/placeholder/RUNTZ_2.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/RUNTZ/mobile/RUNTZ_3.webp",
    //       placeholder: "../media/main/RUNTZ/placeholder/RUNTZ_3.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/RUNTZ/mobile/RUNTZ_4.webp",
    //       placeholder: "../media/main/RUNTZ/placeholder/RUNTZ_4.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/RUNTZ/mobile/RUNTZ_5.webp",
    //       placeholder: "../media/main/RUNTZ/placeholder/RUNTZ_5.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/RUNTZ/mobile/RUNTZ_1.webp",
    //       placeholder: "../media/main/RUNTZ/placeholder/RUNTZ_1.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/RUNTZ/mobile/RUNTZ_6.webp",
    //       placeholder: "../media/main/RUNTZ/placeholder/RUNTZ_6.webp"
    //     }
    //   ]
    // },
    // {
    //   title: "Shooters",
    //   artist: "Trapstar",
    //   feature: null,
    //   vimeo: "https://vimeo.com/1057133425/dcf0ccc390", 
    //   aspectRatio: 4/3,
    //   tags : [2],
    //   credits: {
    //     producer: "Adam John Watts",
    //     pa: "Tomas Leslie",
    //     first_ad: "Billy French",
    //     second_ad: "Jodie Joy",
    //     thirdAD: "Esme Vimes",
    //     runner: "Fergus Rae Smith",
    //     dop: "Michael R. Johnson",
    //     first_ac: "Mindaugas Kairys",
    //     editor: "Archie Erskine",
    //     colourist: "Alexandre Nerzic",
    //     colourProducer: "Alexander Wilson-Thame",
    //     sound_design: "George Blomiley",
    //     leadBaller: "Spillberg",
    //     deadBaller: "Daniels Dunia"
    //   },
    //   meta: {
    //     date: "July 2024",
    //     runTime: [1, 12],
    //     coords: ["51.5072", "0.1276° W"],
    //     location: "London",
    //   },
    //   description: "Shooting hoops at sunset in East London. ",
    //   keywords: ["commercial", "arri alexa"],
    //   content: {
    //     rollingTitle: [
    //       " TRAPSTAR SHOOTERS. TRAPSTAR SHOOTERS. TRAPSTAR SHOOTERS. TRAPSTAR SHOOTERS. ",
    //       " TRAPSTAR SHOOTERS. TRAPSTAR SHOOTERS. TRAPSTAR SHOOTERS. "
    //     ],
    //     splitQuote: [
    //       'ME, TALK??',
    //       'PUT SOME BREAD ON IT.'
    //     ],
    //     minorQuote: [
    //       '',
    //       ''
    //     ],
    //     lastQuote: [
    //       "one on one", "RIGHT NOW"
    //     ],
    //     heroQuote: [
    //       '',
    //       ''
    //     ]
    //   },
    //   thumbnails: {
    //     placeholder: "../media/main/SHOOTERS/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
    //     mobile: "../media/main/SHOOTERS/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
    //     laptop: "../media/main/SHOOTERS/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
    //     desktop: "../media/main/SHOOTERS/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
    //   },
    //   gifStyling: {
    //     backgroundImage: "../media/main/SHOOTERS/trim.mp4",
    //     mobileVideo: "../media/main/SHOOTERS/trim_mobile.mp4"
    //   },
    //   stills: [
    //     {
    //       backgroundImage: "../media/main/SHOOTERS/mobile/SHOOTERS_5.webp",
    //       placeholder: "../media/main/SHOOTERS/placeholder/SHOOTERS_5.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/SHOOTERS/mobile/SHOOTERS_0.webp",
    //       placeholder: "../media/main/SHOOTERS/placeholder/SHOOTERS_0.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/SHOOTERS/mobile/SHOOTERS_1.webp",
    //       placeholder: "../media/main/SHOOTERS/placeholder/SHOOTERS_1.webp"
    //     },
        
    //     {
    //       backgroundImage: "../media/main/SHOOTERS/mobile/SHOOTERS_3.webp",
    //       placeholder: "../media/main/SHOOTERS/placeholder/SHOOTERS_3.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/SHOOTERS/mobile/SHOOTERS_4.webp",
    //       placeholder: "../media/main/SHOOTERS/placeholder/SHOOTERS_4.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/SHOOTERS/mobile/SHOOTERS_7.webp",
    //       placeholder: "../media/main/SHOOTERS/placeholder/SHOOTERS_7.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/SHOOTERS/mobile/SHOOTERS_6.webp",
    //       placeholder: "../media/main/SHOOTERS/placeholder/SHOOTERS_6.webp"
    //     },
        
    //     {
    //       backgroundImage: "../media/main/SHOOTERS/mobile/SHOOTERS_2.webp",
    //       placeholder: "../media/main/SHOOTERS/placeholder/SHOOTERS_2.webp"
    //     },
    //   ]
    // },
    {
      title: "Evicted",
      artist: "Nemzzz",
      feature: null,
      vimeo: "https://vimeo.com/1057132656/35bc884a90", 
      aspectRatio: 240/167,
      tags : [1],
      credits: {
        director: "DON PROD",
        DOP: "Michael R. Johnson",
        first_ac: "@Cine.den",
        second_ac: "@oliFilm24",
        photographer: "@lifeofteej",
        socials: "@don.socials",
      },
      meta: {
        date: "October 2024",
        runTime: [2, 41],
        coords: ["51.5072", "0.1276° W"],
        location: "London",
      },
      description: "Heart gone cold like Palmer!",
      keywords: ["music video", "uk rap", "arri alexa"],
      content: {
        rollingTitle: [
          "I just counted a healthy stack and gave that straight to my dad. ",
          "Move mumsy out of the hood, one way so we can't go back. "
        ],
        splitQuote: [
          'Don\'t run',
          'Don\'t trip'
        ],
        minorQuote: [
          '',
          ''
        ],
        lastQuote: [
          "gone cold","like palmer"
        ],
        heroQuote: [
          'She wanna question me, ayy don\'t ask me bae, go ask Reddit.',
          ' - Nemzzz - '
        ]
      },
      thumbnails: {
        placeholder: "../media/main/EVICTED/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/EVICTED/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/EVICTED/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/EVICTED/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/EVICTED/trim.mp4",
        mobileVideo: "../media/main/EVICTED/trim_mobile.mp4"
      },
      stills: [
        {
          backgroundImage: "../media/main/EVICTED/mobile/EVICTED_5.webp",
          placeholder: "../media/main/EVICTED/placeholder/EVICTED_5.webp"
        },
        {
          backgroundImage: "../media/main/EVICTED/mobile/EVICTED_0.webp",
          placeholder: "../media/main/EVICTED/placeholder/EVICTED_0.webp"
        },
        {
          backgroundImage: "../media/main/EVICTED/mobile/EVICTED_1.webp",
          placeholder: "../media/main/EVICTED/placeholder/EVICTED_1.webp"
        },
        
        {
          backgroundImage: "../media/main/EVICTED/mobile/EVICTED_3.webp",
          placeholder: "../media/main/EVICTED/placeholder/EVICTED_3.webp"
        },
        {
          backgroundImage: "../media/main/EVICTED/mobile/EVICTED_4.webp",
          placeholder: "../media/main/EVICTED/placeholder/EVICTED_4.webp"
        },
        {
          backgroundImage: "../media/main/EVICTED/mobile/EVICTED_7.webp",
          placeholder: "../media/main/EVICTED/placeholder/EVICTED_7.webp"
        },
        {
          backgroundImage: "../media/main/EVICTED/mobile/EVICTED_6.webp",
          placeholder: "../media/main/EVICTED/placeholder/EVICTED_6.webp"
        },
        
        {
          backgroundImage: "../media/main/EVICTED/mobile/EVICTED_2.webp",
          placeholder: "../media/main/EVICTED/placeholder/EVICTED_2.webp"
        },
      ]
    },
    // {
    //   title: "WENT UP",
    //   artist: "Kairo Keyz",
    //   feature: null,
    //   vimeo: "https://vimeo.com/1057125811/991b0103f3", 
    //   aspectRatio: 1920/1327,
    //   tags : [1],
    //   credits: {
    //     director: "DON PROD",
    //     produceer: "@alizzieeee",
    //     dop: "Michael R. Johnson",
    //     photographer: "@ramseyramone",
    //     first_ac: "@cine.den",
    //     second_ac: "@oliFilm24",
    //     gaffer: "@jedclist_lighting",
    //     spark: "@sam_1sp",
    //     spark: "@arjunvellcattaree",
    //     edit: "@harry.tatem",
    //     socials: "@don.socials",
    //   },
    //   meta: {
    //     date: "October 2024",
    //     runTime: [2, 2],
    //     coords: ["51.5072", "0.1276° W"],
    //     location: "London",
    //   },
    //   description: "Short but sweet. Pulled out all the tricks on this one.",
    //   keywords: ["music video", "uk rap", "arri alexa", "vfx"],
    //   content: {
    //     rollingTitle: [
    //       "Left hand full up of fifties, look at my hand, man carryin\' \'nough ",
    //       "I'm in the dance with bad ones throwin' up ones, they're pickin' it up "
    //     ],
    //     splitQuote: [
    //       'bands went up ',
    //       'hate went up '
    //     ],
    //     minorQuote: [
    //       'Hear man chat,',
    //       'Same thing.'
    //     ],
    //     lastQuote: [
    //       "I like my", "bitches bad"
    //     ],
    //     heroQuote: [
    //       'Hate when I hear man talkin\' \'nough',
    //       ' - Kairo - '
    //     ]
    //   },
    //   thumbnails: {
    //     placeholder: "../media/main/WENTUP/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
    //     mobile: "../media/main/WENTUP/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
    //     laptop: "../media/main/WENTUP/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
    //     desktop: "../media/main/WENTUP/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
    //   },
    //   gifStyling: {
    //     backgroundImage: "../media/main/WENTUP/trim.mp4",
    //     mobileVideo: "../media/main/WENTUP/trim_mobile.mp4"
    //   },
    //   stills: [
    //     {
    //       backgroundImage: "../media/main/WENTUP/mobile/WENTUP_5.webp",
    //       placeholder: "../media/main/WENTUP/placeholder/WENTUP_5.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/WENTUP/mobile/WENTUP_0.webp",
    //       placeholder: "../media/main/WENTUP/placeholder/WENTUP_0.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/WENTUP/mobile/WENTUP_1.webp",
    //       placeholder: "../media/main/WENTUP/placeholder/WENTUP_1.webp"
    //     },
        
    //     {
    //       backgroundImage: "../media/main/WENTUP/mobile/WENTUP_3.webp",
    //       placeholder: "../media/main/WENTUP/placeholder/WENTUP_3.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/WENTUP/mobile/WENTUP_4.webp",
    //       placeholder: "../media/main/WENTUP/placeholder/WENTUP_4.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/WENTUP/mobile/WENTUP_7.webp",
    //       placeholder: "../media/main/WENTUP/placeholder/WENTUP_7.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/WENTUP/mobile/WENTUP_6.webp",
    //       placeholder: "../media/main/WENTUP/placeholder/WENTUP_6.webp"
    //     },
        
    //     {
    //       backgroundImage: "../media/main/WENTUP/mobile/WENTUP_2.webp",
    //       placeholder: "../media/main/WENTUP/placeholder/WENTUP_2.webp"
    //     },
    //   ]
    // },
    // {
    //   title: "MORE MONEY MORE PROBLEMS",
    //   artist: "HEADIE ONE",
    //   feature: null,
    //   vimeo: "https://vimeo.com/1057125068/98fe1ee28f", 
    //   aspectRatio: 16/9,
    //   tags : [1],
    //   credits: {
    //     director: "DON PROD",
    //     first_ac: "Mindaugas Kairys",
    //     socials: "@don.socials",
    //   },
    //   meta: {
    //     date: "August 2023",
    //     runTime: [3, 3],
    //     coords: null,
    //     location: ["Dubai, UAE", "HELSINKI, RUSSIA",  "Brussels, BELGIUM", "London, UNITED KINGDOM" ]
    //   },
    //   keywords: ["music video", "uk rap"],
    //   content: {
    //     rollingTitle: [
    //       'They want me back in HMP, true, that\'s where this all started. ',
    //       'I\'m a walkin\' target, I seen one of my dogs turn crassis. '
    //     ],
    //     splitQuote: [
    //       "More money", "more problems"
    //     ],
    //     minorQuote: [
    //       'already',
    //       'Made history'
    //     ],
    //     lastQuote: [
    //       "walking", "target"
    //     ],
    //     heroQuote: [
    //       'More money, more problems, I been feelin\' like Biggie',
    //       '- Headie -'
    //     ]
    //   },
    //   thumbnails: {
    //     placeholder: "../media/main/MOREMONEY/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
    //     mobile: "../media/main/MOREMONEY/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
    //     laptop: "../media/main/MOREMONEY/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
    //     desktop: "../media/main/MOREMONEY/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
    //   },
    //   gifStyling: {
    //     backgroundImage: "../media/main/MOREMONEY/trim.mp4",
    //     mobileVideo: "../media/main/MOREMONEY/trim_mobile.mp4"
    //   },
    //   stills: [
    //     {
    //       backgroundImage: "../media/main/MOREMONEY/mobile/MOREMONEY_5.webp",
    //       placeholder: "../media/main/MOREMONEY/placeholder/MOREMONEY_5.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/MOREMONEY/mobile/MOREMONEY_0.webp",
    //       placeholder: "../media/main/MOREMONEY/placeholder/MOREMONEY_0.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/MOREMONEY/mobile/MOREMONEY_1.webp",
    //       placeholder: "../media/main/MOREMONEY/placeholder/MOREMONEY_1.webp"
    //     },
        
    //     {
    //       backgroundImage: "../media/main/MOREMONEY/mobile/MOREMONEY_3.webp",
    //       placeholder: "../media/main/MOREMONEY/placeholder/MOREMONEY_3.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/MOREMONEY/mobile/MOREMONEY_4.webp",
    //       placeholder: "../media/main/MOREMONEY/placeholder/MOREMONEY_4.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/MOREMONEY/mobile/MOREMONEY_7.webp",
    //       placeholder: "../media/main/MOREMONEY/placeholder/MOREMONEY_7.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/MOREMONEY/mobile/MOREMONEY_6.webp",
    //       placeholder: "../media/main/MOREMONEY/placeholder/MOREMONEY_6.webp"
    //     },
        
    //     {
    //       backgroundImage: "../media/main/MOREMONEY/mobile/MOREMONEY_2.webp",
    //       placeholder: "../media/main/MOREMONEY/placeholder/MOREMONEY_2.webp"
    //     },
    //   ]
    // },
  ]